!(function (e) {
  "use strict";
  var t, a, o, i, n, r, s;
  (window.StyleHatch = window.StyleHatch || {}),
    (StyleHatch.Sections = function () {
      (this.constructors = {}),
        (this.instances = []),
        e(document)
          .on("shopify:section:load", this._onSectionLoad.bind(this))
          .on("shopify:section:unload", this._onSectionUnload.bind(this))
          .on("shopify:section:select", this._onSelect.bind(this))
          .on("shopify:section:deselect", this._onDeselect.bind(this))
          .on("shopify:section:reorder", this._onReorder.bind(this))
          .on("shopify:block:select", this._onBlockSelect.bind(this))
          .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
    }),
    (StyleHatch.Sections.prototype = e.extend(
      {},
      StyleHatch.Sections.prototype,
      {
        _createInstance: function (t, a) {
          var o = e(t),
            i = o.attr("data-section-id"),
            n = o.attr("data-section-type");
          if (void 0 !== (a = a || this.constructors[n])) {
            var r = e.extend(new a(t), { id: i, type: n, container: t });
            this.instances.push(r);
          }
        },
        _onSectionLoad: function (t) {
          var a = e("[data-section-id]", t.target)[0];
          a && this._createInstance(a);
        },
        _onSectionUnload: function (e) {
          var t = slate.utils.findInstance(
            this.instances,
            "id",
            e.detail.sectionId
          );
          t &&
            ("function" == typeof t.onUnload && t.onUnload(e),
            (this.instances = slate.utils.removeInstance(
              this.instances,
              "id",
              e.detail.sectionId
            )));
        },
        _onSelect: function (t) {
          var a = slate.utils.findInstance(
            this.instances,
            "id",
            t.detail.sectionId
          );
          a && "function" == typeof a.onSelect && a.onSelect(t),
            e("body").hasClass("panel-open") &&
              (StyleHatch.closePanelMenu(),
              e("html, body").addClass("scroll-lock"),
              setTimeout(function () {
                e("html, body").removeClass("scroll-lock"),
                  e("html, body").animate(
                    { scrollTop: a.$container.offset().top },
                    600
                  );
              }, 400));
        },
        _onDeselect: function (t) {
          var a = slate.utils.findInstance(
            this.instances,
            "id",
            t.detail.sectionId
          );
          a && "function" == typeof a.onDeselect && a.onDeselect(t),
            e("body").hasClass("panel-open") && StyleHatch.closePanelMenu();
        },
        _onReorder: function (e) {
          var t = slate.utils.findInstance(
            this.instances,
            "id",
            e.detail.sectionId
          );
          t && "function" == typeof t.onReorder && t.onReorder(e);
        },
        _onBlockSelect: function (e) {
          var t = slate.utils.findInstance(
            this.instances,
            "id",
            e.detail.sectionId
          );
          t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        },
        _onBlockDeselect: function (e) {
          var t = slate.utils.findInstance(
            this.instances,
            "id",
            e.detail.sectionId
          );
          t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        },
        register: function (t, a) {
          (this.constructors[t] = a),
            e("[data-section-type=" + t + "]").each(
              function (e, t) {
                this._createInstance(t, a);
              }.bind(this)
            );
        },
      }
    )),
    (StyleHatch.cacheSelectors = function () {
      StyleHatch.cache = {
        $body: e("body"),
        $html: e("html"),
        $util: e("header.util"),
        $header: e("header.site-header"),
        $siteNav: e("header.site-header ul.site-nav"),
        $featuredCollection: e(".featured-collection"),
        $addToCartForm: e("#AddToCartForm"),
        $addToCartButton: e("#AddToCart"),
        $cartButton: e("#CartButton"),
        $recoverPasswordLink: e("#RecoverPassword"),
        $hideRecoverPasswordLink: e("#HideRecoverPasswordLink"),
        $recoverPasswordForm: e("#RecoverPasswordForm"),
        $customerLoginForm: e("#CustomerLoginForm"),
        $passwordResetSuccess: e("#ResetSuccess"),
      };
    }),
    (StyleHatch.init = function () {
      document.documentElement.setAttribute(
        "data-useragent",
        navigator.userAgent
      ),
        StyleHatch.cacheSelectors(),
        ("ontouchstart" in window ||
          navigator.maxTouchPoints > 0 ||
          navigator.msMaxTouchPoints > 0) &&
          theme.Helpers.setTouch(),
        (StyleHatch.largeMobile = 700);
      var e = new StyleHatch.Sections();
      e.register("promos-section", StyleHatch.PromosSection),
        e.register("header-section", StyleHatch.HeaderSection),
        e.register("footer-section", StyleHatch.FooterSection),
        e.register("slideshow-section", StyleHatch.SlideshowSection),
        e.register("hero-video-section", StyleHatch.HeroVideoSection),
        e.register(
          "featured-collection-section",
          StyleHatch.FeaturedCollectionSection
        ),
        e.register(
          "simple-collection-section",
          StyleHatch.SimpleCollectionSection
        ),
        e.register("featured-text-section", StyleHatch.PageSection),
        e.register("custom-content-section", StyleHatch.PageSection),
        e.register("looks", StyleHatch.LooksSection),
        e.register("featured-blog-section", StyleHatch.GenericSection),
        e.register("map", StyleHatch.Maps),
        e.register("product-template", StyleHatch.Product),
        e.register(
          "product-recommendations",
          StyleHatch.ProductRecommendations
        ),
        e.register("store-availability", theme.StoreAvailability),
        e.register("collection-template", StyleHatch.Collection),
        e.register("collection-list-template", StyleHatch.Collection),
        e.register("list-collections-template", StyleHatch.ListCollections),
        e.register("blog-template", StyleHatch.BlogArticle),
        e.register("article-template", StyleHatch.BlogArticle),
        e.register("password-template", StyleHatch.Password),
        e.register("cart-template", StyleHatch.Cart),
        StyleHatch.AjaxCart.init(),
        StyleHatch.loginForms(),
        StyleHatch.videoLayout(),
        StyleHatch.initTemplates();
      var t,
        a = !1;
      document.body.addEventListener("touchstart", function (e) {
        e.target.closest("[data-flickity-options]")
          ? ((a = !0), (t = { x: e.touches[0].pageX, y: e.touches[0].pageY }))
          : (a = !1);
      }),
        document.body.addEventListener(
          "touchmove",
          function (e) {
            if (a && e.cancelable) {
              var o = {
                x: e.touches[0].pageX - t.x,
                y: e.touches[0].pageY - t.y,
              };
              Math.abs(o.x) > 5 && e.preventDefault();
            }
          },
          { passive: !1 }
        );
    }),
    (StyleHatch.PromosSection = function (t) {
      (this.$container = e(t)).attr("data-section-id"),
        StyleHatch.Promos.init();
    }),
    (StyleHatch.PromosSection.prototype = e.extend(
      {},
      StyleHatch.PromosSection.prototype,
      {
        onUnload: function () {
          StyleHatch.Promos.unload();
        },
        onBlockSelect: function (e) {
          StyleHatch.Promos.blockSelect(e);
        },
        onBlockDeselect: function (e) {
          StyleHatch.Promos.blockDeselect(e);
        },
      }
    )),
    (StyleHatch.Promos = (function () {
      var t = "body",
        a = "#page",
        o = "#shopify-section-promos",
        i = "header.promo-bar",
        n = ".promo-bar-container.bottom",
        r = ".promo-popup",
        s = {};
      s = { scrollLock: !1, fixToZIndex: 992, hideTimers: [], slideSpeed: 400 };
      var l = {};
      function c() {
        l.$promos.data("fixtoInstance") && l.$promos.fixTo("destroy");
      }
      return (
        e.fn.extend({
          showPopup: function (t) {
            var a = e(this),
              o = !0,
              i = (a.data("show-delay"), a.data("show-again-delay")),
              n = a.data("homepage-limit"),
              r = a.data("visitor-limit"),
              s = a.data("visitor"),
              c = (a.data("show-for"), a.data("type"));
            1 == r && 0 == s && (o = !1);
            var d = "popup-" + a.data("id");
            e.cookie(d) && (o = !1),
              n && !l.$body.hasClass("template-index") && (o = !1),
              window.self !== window.top && "popup" == c && (o = !1),
              t && (o = !0);
            var u = a.find(".errors"),
              p = getQueryString("contact%5Btags%5D");
            (u.length &&
              p.includes("popup") &&
              ((o = !0), a.find("input#email").addClass("errors")),
            u.length && p.includes("signup-bar") && (o = !0),
            theme.Helpers.isTouch() && a.find("form").removeAttr("target"),
            o) &&
              ("popup" == c &&
                e.magnificPopup.open({
                  items: { src: a, type: "inline", showCloseBtn: !1 },
                  mainClass: "mfp-slideup",
                  removalDelay: 300,
                  callbacks: {
                    close: function () {
                      e.cookie(d, "shown", {
                        expires: i,
                        path: StyleHatch.routes.root_url,
                      });
                    },
                  },
                }),
              "signup-bar" == c &&
                (t ? a.addClass("visible force") : a.addClass("visible")),
              a.find(".icon-text").on("click", function (e) {
                a.hidePopup(), e.preventDefault();
              }),
              a.find("form").on("submit", function (t) {
                if (!t.target.checkValidity()) return !1;
                a.hidePopup(), e(this).submit();
              }));
          },
          hidePopup: function () {
            e("#shopify-section-promos");
            var t = e(this),
              a = t.data("type"),
              o = t.data("id");
            if (("popup" == a && e.magnificPopup.close(), "signup-bar" == a)) {
              var i = "popup-" + o;
              e.cookie(i, "shown", {
                expires: 60,
                path: StyleHatch.routes.root_url,
              }),
                e(".promo-bar.signup-bar").each(function (t) {
                  e(this).slideUp({
                    duration: 400,
                    progress: function () {
                      StyleHatch.refreshFixTo();
                    },
                    complete: function () {
                      StyleHatch.refreshFixTo(),
                        e(this).removeClass("visible force");
                    },
                  });
                });
            }
          },
          promoSlideUp: function () {
            e(this).slideUp({
              duration: s.slideSpeed,
              progress: StyleHatch.refreshFixTo,
              complete: StyleHatch.refreshFixTo,
            });
          },
          promoSlideDown: function () {
            e(this).slideDown({
              duration: s.slideSpeed,
              progress: StyleHatch.refreshFixTo,
              complete: StyleHatch.refreshFixTo,
            });
          },
          showMockPopup: function () {
            var t = e("#shopify-section-promos");
            e(".mock-popup-container").length ||
              t
                .find(">*:first")
                .append('<div class="mock-popup-container"></div>');
            var a = e(".mock-popup-container"),
              o = e(this);
            o.appendTo(a), a.show(), o.show();
          },
          hideMockPopup: function () {
            var t = e(".mock-popup-container"),
              a = e(this);
            t.hide(), a.hide();
          },
        }),
        {
          init: function () {
            (l = {
              $body: e(t),
              $promos: e(o),
              $promosContainer: e(o).find(">*:first"),
              $promoBar: e(i),
              $bottomContainer: e(n),
              $popup: e(r),
            }),
              (s.scrollLock = l.$promos.find(">*:first").data("scroll-lock")),
              l.$promoBar.length &&
                (l.$promoBar.each(function () {
                  var t = e(this),
                    a = t.data("hide-delay"),
                    o = t.data("bar-placement"),
                    i = t.find("div.errors");
                  i.length && i.prependTo(t),
                    "bottom" == o &&
                      (l.$bottomContainer.length ||
                        (l.$promosContainer.append(
                          '<div class="promo-bar-container bottom"></div>'
                        ),
                        (l.$bottomContainer = e(n))),
                      t.appendTo(l.$bottomContainer),
                      l.$bottomContainer.resize(function () {
                        var t = e(this).height() + "px";
                        l.$body.css({ "margin-bottom": t });
                      })),
                    t.hasClass("signup-bar") && t.showPopup(),
                    "no-delay" !== a &&
                      s.hideTimers.push(
                        setTimeout(function () {
                          t.data("pause-hide") || t.promoSlideUp();
                        }, a)
                      );
                }),
                c(),
                s.scrollLock && l.$promos.fixTo(a, { zIndex: s.fixToZIndex })),
              l.$popup.length &&
                l.$popup.each(function () {
                  var t = e(this),
                    a = t.data("show-delay"),
                    o =
                      (t.data("homepage-limit"),
                      t.data("visitor-limit"),
                      t.data("visitor"),
                      t.data("show-for"));
                  t.find(".errors").length && (a = 0),
                    setTimeout(function () {
                      var a = e(window).width();
                      switch (o) {
                        case "mobile":
                          a <= StyleHatch.largeMobile && t.showPopup();
                          break;
                        case "desktop":
                          a > StyleHatch.largeMobile && t.showPopup();
                          break;
                        case "both":
                          t.showPopup();
                      }
                    }, a);
                }),
              StyleHatch.Header.rebuildFixTo();
          },
          unload: function () {
            if (void 0 !== s.hideTimers && s.hideTimers instanceof Array) {
              for (var t = 0; t < s.hideTimers.length; t++)
                clearTimeout(s.hideTimers[t]);
              s.hideTimers.length = 0;
            } else s.hideTimers = [];
            c(),
              StyleHatch.refreshFixTo(),
              l.$bottomContainer.remove(),
              e.magnificPopup.close();
          },
          blockSelect: function (t) {
            var a = e("#block-" + t.detail.blockId),
              o = a.data("type");
            switch ((e.magnificPopup.close(), o)) {
              case "announcement-bar":
                a.promoSlideDown(), a.attr("data-pause-hide", !0);
                break;
              case "popup":
                a.showMockPopup();
                break;
              case "signup-bar":
                a.showPopup(!0);
            }
            StyleHatch.Header.rebuildFixTo(), StyleHatch.refreshFixTo();
          },
          blockDeselect: function (t) {
            var a = e("#block-" + t.detail.blockId),
              o = a.data("type"),
              i = a.data("show-for"),
              n = e(window).width();
            switch (o) {
              case "announcement-bar":
                var r = a;
                r.attr("data-pause-hide", !1);
                var l = r.data("hide-delay");
                r.data("bar-placement"), r.data("homepage-limit");
                (("desktop" == i && n <= StyleHatch.largeMobile) ||
                  ("mobile" == i && n > StyleHatch.largeMobile)) &&
                  a.promoSlideUp(),
                  "no-delay" !== l &&
                    s.hideTimers.push(
                      setTimeout(function () {
                        r.data("pause-hide") || r.promoSlideUp();
                      }, l)
                    );
                break;
              case "popup":
                a.hideMockPopup();
                break;
              case "signup-bar":
                "desktop" == i &&
                  n <= StyleHatch.largeMobile &&
                  (a.hidePopup(), StyleHatch.refreshFixTo()),
                  "mobile" == i &&
                    n > StyleHatch.largeMobile &&
                    (a.hidePopup(), StyleHatch.refreshFixTo());
            }
            StyleHatch.Header.rebuildFixTo();
          },
          refreshFixTo: function () {
            l.$promos.data("fixtoInstance") && l.$promos.fixTo("refresh");
          },
        }
      );
    })()),
    (StyleHatch.HeaderSection = function (t) {
      (this.$container = e(t)).attr("data-section-id"),
        StyleHatch.Header.init();
    }),
    (StyleHatch.HeaderSection.prototype = e.extend(
      {},
      StyleHatch.HeaderSection.prototype,
      {
        onUnload: function () {
          StyleHatch.Header.unload();
        },
      }
    )),
    (StyleHatch.Header = (function () {
      var t = "html, body",
        a = "body",
        o = "#page",
        i = "#shopify-section-header",
        n = "#shopify-section-promos",
        r = "header.util",
        s = "header.site-header",
        l = "header.site-header ul.site-nav",
        c = ".menu-link",
        d = "#menu.panel",
        u = ".mobile-menu-overlay",
        p = "#localization_form--top-bar [data-disclosure-locale]",
        h = "#localization_form--top-bar [data-disclosure-currency]",
        f = {};
      f = {
        blurTimer: {},
        blurTime: 2e3,
        slideSpeed: 300,
        dropdownActiveClass: "dropdown-hover",
        subDropdownActiveClass: "sub-dropdown-hover",
      };
      var m = {};
      function y() {
        m = {
          $htmlBody: e(t),
          $body: e(a),
          $page: e(o),
          $section: e(i),
          $promosSection: e(n),
          $util: e(r),
          $header: e(s),
          $siteNav: e(l),
          $dropdownParent: e(l).find("li.has-dropdown"),
          $defaultLink: e(l).find("> li:not(.has-dropdown)"),
          $subMenuLinks: e(l).find("li.has-dropdown a"),
          $subDropdownParent: e(l).find("li.has-sub-dropdown"),
          $search: e(r).find(".search-wrapper"),
          $searchLink: e(r).find("a.search"),
          $searchClose: e(r).find("form.search-bar button"),
          $searchInput: e(r).find("form.search-bar input"),
          $disclosureLocale: e(p),
          $disclosureCurrency: e(h),
          $menuLink: e(c),
          $menuPanel: e(d),
          $menuPanelDropdown: e(d).find("li.has-dropdown"),
          $menuPanelSubDropdown: e(d).find("li.has-sub-dropdown"),
        };
      }
      function v() {
        m.$search.slideDown({
          duration: f.slideSpeed,
          progress: function () {
            StyleHatch.refreshFixTo();
          },
          complete: function () {
            StyleHatch.refreshFixTo();
          },
        }),
          m.$searchInput.focus();
      }
      function g() {
        m.$searchInput.blur(),
          clearTimeout(f.blurTimer),
          m.$search.slideUp({
            duration: f.slideSpeed,
            progress: function () {
              StyleHatch.refreshFixTo();
            },
            complete: function () {
              StyleHatch.refreshFixTo();
            },
          });
      }
      function b() {
        m.$body.hasClass("panel-open") ? S() : w();
      }
      function w() {
        m.$htmlBody.addClass("panel-open"),
          window.scrollTo(0, 0),
          m.$menuPanel.attr("tabindex", "0"),
          m.$menuPanel.focus();
      }
      function S() {
        m.$htmlBody.addClass("panel-open-transition"),
          m.$htmlBody.removeClass("panel-open"),
          m.$menuPanel.removeAttr("tabindex"),
          setTimeout(function () {
            m.$htmlBody.removeClass("panel-open-transition");
          }, 400);
      }
      function T(e) {
        e.removeClass(f.dropdownActiveClass),
          m.$body.off("touchstart"),
          e.find("> a").attr("aria-expanded", "false"),
          e.find("ul.dropdown").attr("aria-hidden", "true"),
          e.find("ul.dropdown > li > a").attr("tabindex", "-1");
      }
      function _(t) {
        T(e("." + f.subDropdownActiveClass)),
          t.addClass(f.subDropdownActiveClass),
          t.find("> a").attr("aria-expanded", "true"),
          t.find("ul.sub-dropdown").attr("aria-hidden", "false"),
          t.find("ul.sub-dropdown > li > a").attr("tabindex", "0"),
          t.find(".sub-dropdown").offset().left +
            t.find(".sub-dropdown").width() >
          e(window).width()
            ? t.addClass("alternate-align")
            : t.removeClass("alternate-align");
      }
      function k(e) {
        e.removeClass(f.subDropdownActiveClass),
          e.removeClass("alternate-align"),
          e.find("> a").attr("aria-expanded", "false"),
          e.find("ul.sub-dropdown").attr("aria-hidden", "true"),
          e.find("ul.sub-dropdown > li > a").attr("tabindex", "-1");
      }
      function C() {
        var t = e("header.util, #shopify-section-header").filter(function () {
          return e(this).data("fixtoInstance");
        });
        t.length && t.fixTo("destroy");
      }
      function $() {
        y(),
          C(),
          (function () {
            var t = m.$section,
              a = m.$promosSection,
              o = m.$header,
              i = m.$util,
              n = o.data("scroll-lock");
            if ("util" == n || "header" == n) {
              var r = "";
              a.data("fixtoInstance") && (r = "#shopify-section-promos"),
                i.fixTo("#page", { zIndex: 991, mind: r });
            }
            if ("header" == n) {
              r = "header.util";
              a.data("fixtoInstance") &&
                (r = "header.util, #shopify-section-promos"),
                t.fixTo("#page", { zIndex: 990, mind: r }),
                t.resize(function () {
                  e(this).width() <= 700 ? t.fixTo("stop") : t.fixTo("start");
                });
            }
          })();
      }
      return {
        init: function () {
          y(),
            (function () {
              e(u).length ||
                (m.$section.append('<div class="mobile-menu-overlay"></div>'),
                (m.$menuOverlay = e(u)));
              m.$disclosureLocale.length &&
                (StyleHatch.Header.disclosureLocale = new theme.Disclosure(
                  m.$disclosureLocale
                ));
              m.$disclosureCurrency.length &&
                (StyleHatch.Header.disclosureCurrency = new theme.Disclosure(
                  m.$disclosureCurrency
                ));
            })(),
            m.$searchLink.on("click.search", function (e) {
              v(), e.preventDefault();
            }),
            m.$searchClose.on("click.search", function (e) {
              g(), e.preventDefault();
            }),
            m.$searchInput.on("blur.search", function (e) {
              (f.blurTimer = setTimeout(g, f.blurTime)), e.preventDefault();
            }),
            m.$menuLink.on("click.panel", function (e) {
              b(), e.preventDefault();
            }),
            m.$menuOverlay.on("click.panel", function (e) {
              b(), e.preventDefault();
            }),
            m.$menuPanelDropdown.on("click.panelDropdown", function (t) {
              m.$menuPanelDropdown.find("ul.dropdown").slideUp(),
                m.$menuPanelDropdown.find("> a").attr("aria-expanded", "false"),
                m.$menuPanelDropdown.removeClass("expanded"),
                m.$menuPanelDropdown
                  .find("ul.dropdown")
                  .attr("aria-hidden", "true"),
                m.$menuPanelDropdown
                  .find("ul.dropdown a")
                  .attr("tabindex", "-1"),
                e(this).find("ul.dropdown").is(":visible") ||
                  (e(this).find("> a").attr("aria-expanded", "true"),
                  e(this).find("ul.dropdown").slideDown(),
                  e(this).find("ul.dropdown").attr("aria-hidden", "false"),
                  e(this).find("ul.dropdown > li > a").attr("tabindex", "0"),
                  e(this).addClass("expanded"));
            }),
            m.$menuPanelDropdown
              .find("> a")
              .on("click.panelDropdown", function (t) {
                e(this).closest("li").hasClass("expanded") ||
                  t.preventDefault();
              }),
            m.$menuPanelDropdown
              .find("ul.dropdown li:not(.has-sub-dropdown) a")
              .on("click.panelDropdown", function (e) {
                e.stopPropagation();
              }),
            m.$menuPanelSubDropdown.on("click.panelDropdown", function (t) {
              t.stopPropagation(),
                m.$menuPanelSubDropdown.find("ul.sub-dropdown").slideUp(),
                m.$menuPanelDropdown.find("> a").attr("aria-expanded", "false"),
                m.$menuPanelSubDropdown.removeClass("expanded"),
                m.$menuPanelDropdown
                  .find("ul.sub-dropdown")
                  .attr("aria-hidden", "true"),
                m.$menuPanelDropdown
                  .find("ul.sub-dropdown a")
                  .attr("tabindex", "-1"),
                e(this).find("ul.sub-dropdown").is(":visible") ||
                  (e(this).find("> a").attr("aria-expanded", "true"),
                  e(this).find("ul.sub-dropdown").slideDown(),
                  e(this).find("ul.sub-dropdown").attr("aria-hidden", "false"),
                  e(this)
                    .find("ul.sub-dropdown > li > a")
                    .attr("tabindex", "0"),
                  e(this).addClass("expanded"));
            }),
            m.$menuPanelSubDropdown
              .find("> a")
              .on("click.panelDropdown", function (t) {
                e(this).closest("li").hasClass("expanded") ||
                  t.preventDefault();
              }),
            m.$menuPanelSubDropdown
              .find("ul.sub-dropdown a")
              .on("click.panelDropdown", function (e) {
                e.stopPropagation();
              }),
            m.$promosSection.resize(StyleHatch.refreshFixTo),
            m.$subMenuLinks.each(function () {
              var t = e(this).text();
              wordWrapper(t, 24, "<br/>\n");
            }),
            T(m.$dropdownParent),
            (function () {
              m.$dropdownParent.on(
                "mouseenter.dropdown touchstart.dropdown focusin.dropdown",
                function (t) {
                  var a = e(this);
                  a.hasClass(f.dropdownActiveClass) ||
                    (t.preventDefault(),
                    (function (t) {
                      T(e("." + f.dropdownActiveClass)),
                        t.addClass(f.dropdownActiveClass),
                        t.find("> a").attr("aria-expanded", "true"),
                        t.find("ul.dropdown").attr("aria-hidden", "false"),
                        t.find("ul.dropdown > li > a").attr("tabindex", "0");
                      var a = t.find("ul.dropdown");
                      a.hasClass("dropdown--mega-menu") ||
                        a.css({ left: "auto" });
                      var o = a.offset().left + a.outerWidth(),
                        i = e(window).width(),
                        n = m.$header.width(),
                        r = m.$header.find(".logo-nav-contain").offset().left;
                      n + 40 > e(window).width() &&
                        ((n = e(window).width()), (r = -20));
                      if (
                        o > (i = n + r + 1) &&
                        !a.hasClass("dropdown--mega-menu")
                      ) {
                        var s = "-" + (o - i) + "px";
                        a.css({ left: s });
                      }
                      setTimeout(function () {
                        m.$body.on("touchstart", function () {
                          T(t);
                        });
                      }, 250);
                    })(a));
                }
              ),
                m.$dropdownParent.on("mouseleave.dropdown", function () {
                  T(e(this));
                }),
                m.$subMenuLinks.on("touchstart.dropdown", function (e) {
                  e.stopImmediatePropagation();
                }),
                m.$subDropdownParent.on(
                  "mouseenter.subdropdown touchstart.subdropdown focusin.subdropdown",
                  function (t) {
                    var a = e(this);
                    a.hasClass(f.subDropdownActiveClass) ||
                      (t.preventDefault(), _(a));
                  }
                ),
                m.$subDropdownParent.on("mouseleave.subdropdown", function () {
                  k(e(this));
                }),
                m.$subDropdownParent.on("touchstart.subdropdown", function (e) {
                  e.stopImmediatePropagation();
                }),
                e("html").hasClass("touchevents") &&
                  m.$subDropdownParent.children("a").on("click", function (t) {
                    var a = e(this);
                    a.hasClass(f.subDropdownActiveClass) ||
                      (t.preventDefault(), _(a));
                  });
              m.$subMenuLinks.on("focusout.dropdown", function (t) {
                null == t.relatedTarget
                  ? T(e("." + f.dropdownActiveClass))
                  : (e(t.target).closest("li.has-dropdown")[0] !==
                      e(t.relatedTarget).closest("li.has-dropdown")[0] &&
                      T(e("." + f.dropdownActiveClass)),
                    e(t.target).closest("li.has-sub-dropdown")[0] !==
                      e(t.relatedTarget).closest("li.has-sub-dropdown")[0] &&
                      k(e("." + f.subDropdownActiveClass)));
              });
            })(),
            e("[data-currency-selector]").on("change", function () {
              e(this).parents("form").submit();
            }),
            $();
        },
        unload: function () {
          S(),
            StyleHatch.Header.disclosureLocale &&
              StyleHatch.Header.disclosureLocale.unload(),
            StyleHatch.Header.disclosureCurrency &&
              StyleHatch.Header.disclosureCurrency.unload(),
            clearTimeout(f.blurTimer),
            m.$searchLink.off("click.search"),
            m.$searchClose.off("click.search"),
            m.$searchInput.off("blur.search"),
            m.$menuLink.off("click.panel"),
            m.$menuPanelDropdown.off("click.panelDropdown"),
            m.$menuPanelDropdown.find("> a").off("click.panelDropdown"),
            m.$menuPanelDropdown
              .find("ul.dropdown li:not(.has-sub-dropdown) a")
              .off("click.panelDropdown"),
            m.$menuPanelSubDropdown.off("click.panelDropdown"),
            m.$menuPanelSubDropdown.find("> a").off("click.panelDropdown"),
            m.$menuPanelSubDropdown
              .find("ul.sub-dropdown a")
              .off("click.panelDropdown"),
            m.$promosSection.removeResize(StyleHatch.refreshFixTo),
            m.$dropdownParent.off(
              "mouseenter.dropdown touchstart.dropdown focusin.dropdown"
            ),
            m.$dropdownParent.off("mouseleave.dropdown"),
            m.$subMenuLinks.off("touchstart.dropdown"),
            m.$subDropdownParent.off(
              "mouseenter.subdropdown touchstart.subdropdown focusin.subdropdown"
            ),
            m.$subDropdownParent.off("mouseleave.subdropdown"),
            m.$subDropdownParent.off("touchstart.subdropdown"),
            m.$subMenuLinks.off("focusout.dropdown"),
            C();
        },
        openSearch: v,
        closeSearch: g,
        togglePanelMenu: b,
        openPanelMenu: w,
        closePanelMenu: S,
        rebuildFixTo: $,
      };
    })()),
    (StyleHatch.FooterSection = function (t) {
      var a = (this.$container = e(t));
      a.attr("data-section-id"), StyleHatch.Footer.init(a);
    }),
    (StyleHatch.FooterSection.prototype = e.extend(
      {},
      StyleHatch.FooterSection.prototype,
      {
        onUnload: function (e) {
          StyleHatch.Footer.unload(e);
        },
      }
    )),
    (StyleHatch.Footer = {
      init: function (t) {
        var a = t.find("ul.nested-menu");
        a.initNestedMenu(),
          (StyleHatch.Footer.$nestedMenu = a),
          e("#localization_form--footer [data-disclosure-locale]").length &&
            (StyleHatch.Footer.disclosureLocale = new theme.Disclosure(
              e("#localization_form--footer [data-disclosure-locale]")
            )),
          e("#localization_form--footer [data-disclosure-currency]").length &&
            (StyleHatch.Footer.disclosureCurrency = new theme.Disclosure(
              e("#localization_form--footer [data-disclosure-currency]")
            ));
      },
      unload: function (e) {
        StyleHatch.Footer.$nestedMenu.destroyNestedMenu(),
          StyleHatch.Footer.disclosureLocale &&
            StyleHatch.Footer.disclosureLocale.unload(),
          StyleHatch.Footer.disclosureCurrency &&
            StyleHatch.Footer.disclosureCurrency.unload();
      },
    }),
    (StyleHatch.SlideshowSection = function (t) {
      var a = (this.$container = e(t));
      a.attr("data-section-id"), StyleHatch.Slideshow.init(a);
    }),
    (StyleHatch.SlideshowSection.prototype = e.extend(
      {},
      StyleHatch.SlideshowSection.prototype,
      {
        onUnload: function (e) {
          StyleHatch.Slideshow.unload(e);
        },
        onBlockSelect: function (e) {
          StyleHatch.Slideshow.blockSelect(e);
        },
        onBlockDeselect: function (e) {
          StyleHatch.Slideshow.blockDeselect(e);
        },
      }
    )),
    (StyleHatch.Slideshow = {
      init: function (t) {
        var a = t.find(".slideshow-carousel"),
          o = a.find(".slide__item");
        e(window).on("resize", function () {
          o.each(function (t) {
            var a;
            (e(window).width() > 700 ||
              (a = e(this).find("img.slide__image-mobile")).length < 1) &&
              (a = e(this).find("img.slide__image-desktop")),
              a.hasClass("lazymanual") &&
                (a
                  .attr("src", a.attr("data-preload"))
                  .removeAttr("data-preload"),
                a.removeClass("lazymanual").addClass("lazyload"));
          });
        });
        var i = a.data("flickity-options");
        a.flickity(i),
          a.parent().find(".flickity-page-dots.placeholder").remove(),
          t.find(".slide__item-video").each(function () {
            var t = e(this).find(".slide__item-image"),
              a = e(this).data("video-id"),
              o = e(this).data("mobile-autoplay"),
              i = 0;
            o && (i = 1),
              (e(window).width() > StyleHatch.largeMobile || o) &&
                t.YTPlayer({
                  fitToBackground: !1,
                  videoId: a,
                  repeat: !0,
                  mute: !0,
                  playerVars: { rel: 0, mute: 1, playsinline: i, autoplay: 1 },
                  callback: function () {
                    e(window).trigger("resize");
                  },
                });
          });
      },
      unload: function (t) {
        var a = e(".slideshow-" + t.detail.sectionId);
        a.find(".slideshow-carousel").flickity("destroy");
        var o = a.find(".slide__item-video .slide__item-image");
        o.removeData("yt-init").removeData("ytPlayer").removeClass("loaded"),
          e(window).off("resize.YTplayer" + o.ID),
          e(window).off("scroll.YTplayer" + o.ID),
          (o.$body = null),
          (o.$node = null),
          (o.$YTPlayerString = null),
          (o.player = null);
      },
      blockSelect: function (t) {
        var a = e("#block-" + t.detail.blockId),
          o = a.closest(".slideshow-carousel"),
          i = a.data("slide-index");
        o.flickity("pausePlayer"),
          o.flickity("select", i, !0, !0),
          o.find("img").removeClass(".lazymanual").addClass("lazyload");
      },
      blockDeselect: function (t) {
        e("#block-" + t.detail.blockId)
          .closest(".slideshow-carousel")
          .flickity("unpausePlayer");
      },
    }),
    (StyleHatch.HeroVideoSection = function (t) {
      var a = (this.$container = e(t));
      a.attr("data-section-id"), StyleHatch.HeroVideo.init(a);
    }),
    (StyleHatch.HeroVideoSection.prototype = e.extend(
      {},
      StyleHatch.HeroVideoSection.prototype,
      {
        onUnload: function (e) {
          StyleHatch.HeroVideo.unload(e);
        },
      }
    )),
    (StyleHatch.HeroVideo = {
      init: function (e) {
        var t = e.find(".wrapper"),
          a = e.data("video-id"),
          o = 0;
        e.data("mobile-autoplay") && (o = 1),
          t.removeData("ytPlayer"),
          t.YTPlayer({
            fitToBackground: !1,
            videoId: a,
            repeat: !0,
            mute: !0,
            playerVars: { rel: 0, mute: 1, playsinline: o, autoplay: 1 },
          });
      },
      unload: function (t) {
        var a = e(".slideshow-" + t.detail.sectionId).find(".wrapper");
        a.removeData("yt-init").removeData("ytPlayer").removeClass("loaded"),
          a.find(".ytplayer-container .ytplayer-shield").remove();
      },
    }),
    (StyleHatch.Maps = (function () {
      var t = 14,
        a = null,
        o = null,
        i = !1,
        n = [],
        r = {
          standard: [],
          silver: [
            { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f5f5" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#ffffff" }],
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#dadada" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#e5e5e5" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#eeeeee" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#c9c9c9" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
          ],
          retro: [
            { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#523735" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry.stroke",
              stylers: [{ color: "#c9b2a6" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "geometry.stroke",
              stylers: [{ color: "#dcd2be" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#ae9e90" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#93817c" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#a5b076" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#447530" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#f5f1e6" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#fdfcf8" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#f8c967" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#e9bc62" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#e98d58" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry.stroke",
              stylers: [{ color: "#db8555" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#806b63" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8f7d77" }],
            },
            {
              featureType: "transit.line",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#ebe3cd" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#dfd2ae" }],
            },
            {
              featureType: "water",
              elementType: "geometry.fill",
              stylers: [{ color: "#b9d3c2" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#92998d" }],
            },
          ],
          dark: [
            { elementType: "geometry", stylers: [{ color: "#212121" }] },
            { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#212121" }],
            },
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "administrative.country",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9e9e9e" }],
            },
            {
              featureType: "administrative.land_parcel",
              stylers: [{ visibility: "off" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#bdbdbd" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#181818" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1b1b1b" }],
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [{ color: "#2c2c2c" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#8a8a8a" }],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [{ color: "#373737" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#3c3c3c" }],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [{ color: "#4e4e4e" }],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [{ color: "#616161" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#757575" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#000000" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3d3d3d" }],
            },
          ],
          night: [
            { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#746855" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#242f3e" }],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [{ color: "#263c3f" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6b9a76" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#38414e" }],
            },
            {
              featureType: "road",
              elementType: "geometry.stroke",
              stylers: [{ color: "#212a37" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#9ca5b3" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#746855" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#1f2835" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#f3d19c" }],
            },
            {
              featureType: "transit",
              elementType: "geometry",
              stylers: [{ color: "#2f3948" }],
            },
            {
              featureType: "transit.station",
              elementType: "labels.text.fill",
              stylers: [{ color: "#d59563" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#17263c" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#515c6d" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#17263c" }],
            },
          ],
          aubergine: [
            { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
            {
              elementType: "labels.text.fill",
              stylers: [{ color: "#8ec3b9" }],
            },
            {
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1a3646" }],
            },
            {
              featureType: "administrative.country",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [{ color: "#64779e" }],
            },
            {
              featureType: "administrative.province",
              elementType: "geometry.stroke",
              stylers: [{ color: "#4b6878" }],
            },
            {
              featureType: "landscape.man_made",
              elementType: "geometry.stroke",
              stylers: [{ color: "#334e87" }],
            },
            {
              featureType: "landscape.natural",
              elementType: "geometry",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [{ color: "#6f9ba5" }],
            },
            {
              featureType: "poi",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "poi.park",
              elementType: "geometry.fill",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [{ color: "#3C7680" }],
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [{ color: "#304a7d" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [{ color: "#2c6675" }],
            },
            {
              featureType: "road.highway",
              elementType: "geometry.stroke",
              stylers: [{ color: "#255763" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [{ color: "#b0d5ce" }],
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#023e58" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [{ color: "#98a5be" }],
            },
            {
              featureType: "transit",
              elementType: "labels.text.stroke",
              stylers: [{ color: "#1d2c4d" }],
            },
            {
              featureType: "transit.line",
              elementType: "geometry.fill",
              stylers: [{ color: "#283d6a" }],
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [{ color: "#3a4762" }],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [{ color: "#0e1626" }],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [{ color: "#4e6d70" }],
            },
          ],
        },
        s = {
          addressNoResults: StyleHatch.Strings.addressNoResults,
          addressQueryLimit: StyleHatch.Strings.addressQueryLimit,
          addressError: StyleHatch.Strings.addressError,
          authError: StyleHatch.Strings.authError,
        },
        l = '[data-section-type="maps"]',
        c = "[data-map]",
        d = "[data-map-overlay]",
        u = "map-selection--load-error",
        p = "map-section__errors errors text-center";
      function h(t) {
        if (
          ((this.$container = e(t)),
          (this.$map = this.$container.find(c)),
          (this.key = this.$map.data("api-key")),
          this.key != o && ((o = this.key), (a = null), (i = !0)),
          void 0 !== this.key)
        )
          if ("loaded" === a) this.createMap();
          else {
            n.push(this);
            var r = this;
            "loading" !== a &&
              ((a = "loading"),
              (void 0 === window.google || i) &&
                e
                  .getScript(
                    "https://maps.googleapis.com/maps/api/js?key=" + this.key
                  )
                  .then(function () {
                    (a = "loaded"),
                      (i = !1),
                      (function (t) {
                        document.addEventListener(
                          "lazybeforeunveil",
                          function (a) {
                            e(a.target).attr("data-section-type") &&
                              t.createMap();
                          }
                        ),
                          e.each(n, function (e, a) {
                            a.$container.hasClass("lazyloaded") &&
                              t.createMap();
                          });
                      })(r);
                  }));
          }
      }
      return (
        (window.gm_authFailure = function () {
          Shopify.designMode
            ? (e(l).addClass(u),
              e(c).remove(),
              e(d).after(
                '<div class="' +
                  p +
                  '">' +
                  StyleHatch.Strings.authError +
                  "</div>"
              ))
            : console.log("Google Maps authentication error", window.google, a);
        }),
        (h.prototype = e.extend({}, h.prototype, {
          createMap: function () {
            var a = this.$map,
              o = a.data("map-style");
            return (function (t) {
              var a = e.Deferred(),
                o = new google.maps.Geocoder(),
                i = t.data("address-setting");
              return (
                o.geocode({ address: i }, function (e, t) {
                  t !== google.maps.GeocoderStatus.OK && a.reject(t),
                    a.resolve(e);
                }),
                a
              );
            })(a)
              .then(
                function (e) {
                  var i = {
                      zoom: t,
                      center: e[0].geometry.location,
                      draggable: !1,
                      clickableIcons: !1,
                      scrollwheel: !1,
                      disableDoubleClickZoom: !0,
                      disableDefaultUI: !0,
                      styles: r[o],
                    },
                    n = (this.map = new google.maps.Map(a[0], i)),
                    s = (this.center = n.getCenter());
                  new google.maps.Marker({ map: n, position: n.getCenter() });
                  google.maps.event.addDomListener(
                    window,
                    "resize",
                    slate.utils.debounce(function () {
                      google.maps.event.trigger(n, "resize"),
                        n.setCenter(s),
                        a.removeAttr("style");
                    }, 250)
                  );
                }.bind(this)
              )
              .fail(function () {
                var e;
                switch (status) {
                  case "ZERO_RESULTS":
                    e = s.addressNoResults;
                    break;
                  case "OVER_QUERY_LIMIT":
                    e = s.addresQueryLimit;
                    break;
                  case "REQUEST_DENIED":
                    e = s.authError;
                    break;
                  default:
                    e = s.addressError;
                }
                Shopify.designMode &&
                  a
                    .parent()
                    .addClass(u)
                    .append('<div class="' + p + '">' + e + "</div>");
              });
          },
          onUnload: function () {
            0 !== this.$map.length &&
              google.maps.event.clearListeners(this.map, "resize");
          },
        })),
        h
      );
    })()),
    (StyleHatch.PageSection = function (t) {
      var a = (this.$container = e(t));
      a.attr("data-section-id"), StyleHatch.Page.init(a);
    }),
    (StyleHatch.Page = {
      init: function (e) {
        e.fitVids();
      },
      unload: function (e) {},
    }),
    (StyleHatch.FeaturedCollectionSection = function (t) {
      var a = (this.$container = e(t));
      a.attr("data-section-id"), a.productBox();
    }),
    (StyleHatch.FeaturedCollectionSection.prototype = e.extend(
      {},
      StyleHatch.FeaturedCollectionSection.prototype,
      {
        onUnload: function (t) {
          var a = e("#section-" + t.detail.sectionId);
          a.attr("data-section-id");
          a.destroyProductBox();
        },
      }
    )),
    (StyleHatch.SimpleCollectionSection = function (t) {
      var a = (this.$container = e(t));
      a.attr("data-section-id"), a.productBox();
    }),
    (StyleHatch.SimpleCollectionSection.prototype = e.extend(
      {},
      StyleHatch.SimpleCollectionSection.prototype,
      {
        onUnload: function (t) {
          var a = e("#section-" + t.detail.sectionId);
          a.attr("data-section-id");
          a.destroyProductBox();
        },
      }
    )),
    (StyleHatch.LooksSection = function (t) {
      var a = (this.$container = e(t));
      a.attr("data-section-id"), StyleHatch.Looks.init(a);
    }),
    (StyleHatch.LooksSection.prototype = e.extend(
      {},
      StyleHatch.LooksSection.prototype,
      {
        onUnload: function (e) {
          StyleHatch.Looks.unload(e);
        },
        onBlockSelect: function (e) {
          StyleHatch.Looks.unload(e);
        },
        onBlockDeselect: function (e) {
          StyleHatch.Looks.unload(e);
        },
      }
    )),
    (StyleHatch.Looks = {
      init: function (t) {
        e(".looks__item--overlay", t).on("click", function (t) {
          var a = e(this).closest(".looks__item");
          if ((a.data("id"), e(this).data("overlay"))) {
            var o = (function (t) {
              var a = e(".looks__overlay", t);
              if (0 === a.length) {
                var o = e(".looks__products", t),
                  i = e(".card__image-wrapper", t).clone(),
                  n = e(".looks__caption", t).clone(),
                  r = e(".looks__caption--text", n);
                r.html(r.attr("data-rte")),
                  o.wrap(
                    '<div class="looks__overlay"><div class="looks__overlay-content"></div></div>'
                  ),
                  (a = e(".looks__overlay", t)),
                  e(".looks__overlay-content", t).prepend(n),
                  a.prepend('<div class="looks__overlay-image"></div>'),
                  e(".looks__overlay-image", t).append(i);
              }
              return a;
            })(a);
            e.magnificPopup.open({
              items: { src: o, type: "inline" },
              callbacks: {
                open: function () {
                  e(".mfp-content .looks__overlay img.card__image")
                    .removeClass("lazyloaded")
                    .addClass("lazyload"),
                    slate.a11y.trapFocus({
                      $container: e(".mfp-content .looks__overlay"),
                      namespace: "looksOverlayFocus",
                    });
                },
                close: function () {
                  slate.a11y.removeTrapFocus({
                    $container: e(".mfp-content .looks__overlay"),
                    namespace: "looksOverlayFocus",
                  });
                },
              },
            }),
              t.preventDefault();
          }
        });
      },
      unload: function (t) {
        e.magnificPopup.close();
      },
    }),
    (StyleHatch.GenericSection = function (t) {
      (this.$container = e(t)).attr("data-section-id"),
        StyleHatch.cacheSelectors();
    }),
    (StyleHatch.Product = (function () {
      function t(t) {
        var a = (this.$container = e(t)),
          o = a.attr("data-section-id");
        if (
          ((this.settings = {
            enableHistoryState: a.data("enable-history-state") || !1,
            enableSwatch: a.data("enable-swatch") || !1,
            imageSize: "394x",
            imageZoomSize: null,
            namespace: ".product-" + o,
            sectionId: o,
            zoomEnabled: !1,
            lightboxEnabled: !1,
            productImageLightboxData: [],
          }),
          (this.selectors = {
            addToCartForm: "#AddToCartForm-" + o,
            addToCart: "#AddToCart-" + o,
            addToCartText: "#AddToCartText-" + o,
            comparePrice: "#ComparePrice-" + o,
            savings: "#Savings-" + o,
            originalPrice: "#ProductPrice-" + o,
            SKU: ".variant-sku",
            originalSelectorId: "#ProductSelect-" + o,
            productFeaturedImage: "#FeaturedImage-" + o,
            productImageWrap: ".featured-container-" + o,
            productPrices: ".product-single__price-" + o,
            productThumbImages: ".product-single__thumbnail--" + o,
            productPhoto: "#ProductPhoto-" + o,
            productImage: "#ProductImage-" + o,
            productThumbs: "#ProductThumbs-" + o,
            quantityWrap: ".quantity-" + o,
            quantity: ".quantity-select-" + o,
            cartError: ".cart-error-" + o,
            singleOptionSelector: ".single-option-selector-" + o,
            cartButtons: "#CartButtons-" + o,
            paymentButtonContainer: "#PaymentButtonContainer-" + o,
            productSizeGuideLink: "a.product-size-guide-" + o,
            productSizeGuideContent: "#product-size-guide-content-" + o,
            productMediaWrapper: "[data-product-single-media-wrapper]",
            productMediaTypeVideo: "[data-product-media-type-video]",
            productMediaTypeModel: "[data-product-media-type-model]",
            productMediaGroup: "[data-product-single-media-group]",
            priceContainer: "[data-price]",
            unitPrice: "[data-unit-price]",
            unitPriceBaseUnit: "[data-unit-price-base-unit]",
            storeAvailabilityContainer: "[data-store-availability-container]",
          }),
          (this.classes = {
            activeMedia: "active-media",
            productUnitAvailable: "price--unit-available",
          }),
          this._initSlider(),
          e("#ProductJson-" + o).html())
        ) {
          (this.productSingleObject = JSON.parse(
            document.getElementById("ProductJson-" + o).innerHTML
          )),
            (this.settings.zoomEnabled = e(
              this.selectors.productImageWrap
            ).hasClass("featured-zoom")),
            "objectFit" in document.documentElement.style == !0 &&
              (this.settings.lightboxEnabled = e(
                this.selectors.productImageWrap
              ).data("lightbox")),
            a.productBox(),
            (this.storeAvailabilityContainer = t.querySelector(
              this.selectors.storeAvailabilityContainer
            )),
            this.storeAvailabilityContainer &&
              (this.storeAvailability = new theme.StoreAvailability(
                this.storeAvailabilityContainer
              )),
            this._initVariants(),
            this._initQuanitySelect(),
            this._initProductVideo(),
            this._initModelViewerLibraries(),
            this._initShopifyXrLaunch(),
            e(this.selectors.productSizeGuideLink).length &&
              e(this.selectors.productSizeGuideLink).magnificPopup({
                items: {
                  src: e(this.selectors.productSizeGuideContent),
                  type: "inline",
                },
              });
          var i = a.find(".description__tabs");
          i.find(".tab");
          i.find(".tab__title").on("click keydown", function (t) {
            var a = !1;
            if (
              ("click" === t.type && (a = !0),
              "keydown" === t.type && "Enter" == t.key && (a = !0),
              a)
            ) {
              var o = e(this).closest(".tab"),
                n = i.find(".tab--active");
              o.hasClass("tab--active")
                ? (o.removeClass("tab--active"),
                  o.find(".tab__content").slideUp(400))
                : (n.removeClass("tab--active"),
                  n.find(".tab__content").slideUp(400),
                  o.addClass("tab--active"),
                  o.find(".tab__content").slideDown(400),
                  setTimeout(function () {
                    o.find(".tab__title").scrollIntoView({
                      duration: 400,
                      direction: "vertical",
                      viewPadding: { y: 0 },
                    });
                  }, 400));
            }
          });
        }
      }
      return (
        (t.prototype = e.extend({}, t.prototype, {
          _initVariants: function () {
            var e = {
              $container: this.$container,
              enableHistoryState:
                this.$container.data("enable-history-state") || !1,
              enableSwatch: this.$container.data("enable-swatch"),
              singleOptionSelector: this.selectors.singleOptionSelector,
              originalSelectorId: this.selectors.originalSelectorId,
              product: this.productSingleObject,
            };
            (this.optionsMap = {}),
              (this.variants = new slate.Variants(e)),
              this.storeAvailability &&
                this.storeAvailability.updateContent(
                  this.variants.currentVariant.id,
                  this.productSingleObject.title
                ),
              e.enableSwatch &&
                (this._linkOptionSelectors(this.productSingleObject),
                this.$container.on(
                  "variantSwatchChange" + this.settings.namespace,
                  this._updateSwatches.bind(this)
                )),
              this.$container.on(
                "variantChange" + this.settings.namespace,
                this._updateAvailability.bind(this)
              ),
              this.$container.on(
                "variantImageChange" + this.settings.namespace,
                this._updateImages.bind(this)
              ),
              this.$container.on(
                "variantPriceChange" + this.settings.namespace,
                this._updatePrice.bind(this)
              ),
              this.$container.on(
                "variantSKUChange" + this.settings.namespace,
                this._updateSKU.bind(this)
              );
            var t = this.variants.currentVariant;
            this.$container.trigger({
              type: "variantChange" + this.settings.namespace,
              variant: t,
            });
          },
          _initQuanitySelect: function () {
            e(this.selectors.quantity).each(function () {
              var t = e(this),
                a = t.find(".adjust-minus"),
                o = t.find(".adjust-plus"),
                i = t.find("input.quantity"),
                n = i.val();
              a.on("click", function (e) {
                (n = i.val()) > 1 && (n--, i.val(n)), e.preventDefault();
              }),
                o.on("click", function (e) {
                  (n = i.val()), n++, i.val(n), e.preventDefault();
                });
            });
          },
          _switchInert: function (t) {
            var a = e(
                this.selectors.productMediaWrapper +
                  '[data-media-id="' +
                  t +
                  '"]'
              ),
              o = e(
                this.selectors.productMediaWrapper +
                  ':not([data-media-id="' +
                  t +
                  '"])'
              );
            a.removeAttr("inert"), o.attr("inert", "true");
          },
          _switchMedia: function (t) {
            var a,
              o = e(
                this.selectors.productMediaWrapper +
                  '[data-media-id="' +
                  t +
                  '"]'
              ),
              i = e(
                this.selectors.productMediaWrapper +
                  ':not([data-media-id="' +
                  t +
                  '"])'
              ),
              n = o.attr("data-media-type");
            switch (n) {
              case "model":
                a = o.find(".product-single__media model-viewer");
                break;
              case "external_video":
                a = o.find(".product-single__media iframe");
                break;
              case "video":
                a = o.find(".product-single__media .plyr");
            }
            waitFor(
              function () {
                return "image" === n || isFocusable(a[0]);
              },
              function () {}
            ),
              i.trigger("mediaHidden").removeClass(this.classes.activeMedia),
              o.trigger("mediaVisible").addClass(this.classes.activeMedia),
              "model" == o.attr("data-media-type")
                ? (this.flkty.options.draggable = !1)
                : (this.flkty.options.draggable = !0),
              this.flkty.updateDraggable();
          },
          _initSlider: function () {
            var t = this.$container.find(".product-image--slider");
            if (t.length) {
              var a = t.data("flickity-options"),
                o = t.data("slider-enabled"),
                i = t.data("zoom"),
                n = t.data("lightbox"),
                r = (u = t.find("[data-initial-image]"))
                  .parent()
                  .find(".product-image--cell")
                  .index(u);
              (a.initialIndex = r),
                o ||
                  ((a.draggable = !1),
                  (a.selectedAttraction = 1),
                  (a.friction = 1)),
                u.removeAttr("data-initial-image"),
                t.flickity(a),
                (this.flkty = t.data("flickity")),
                "model" == u.attr("data-media-type") &&
                  ((this.flkty.options.draggable = !1),
                  this.flkty.updateDraggable()),
                t.parent().find(".flickity-page-dots.placeholder").remove();
              var s = this;
              t.on("change.flickity", function (t, a) {
                var o = e(this)
                  .find(".product-image--cell")
                  .eq(a)
                  .attr("data-media-id");
                s._switchInert(o);
              });
              var l = !1;
              if (
                (t.on("settle.flickity", function (t, a) {
                  if (l) {
                    var o = e(this)
                      .find(".product-image--cell")
                      .eq(a)
                      .attr("data-media-id");
                    s._switchMedia(o);
                  }
                  l = !0;
                }),
                !theme.Helpers.isTouch() && i)
              ) {
                e('.product-image--cell[data-media-type="image"]').easyZoom();
                t.on("dragStart.flickity", function (t) {
                  e(t.currentTarget)
                    .find(".easyzoom-flyout")
                    .addClass("hidden");
                }).on("dragEnd.flickity", function (t) {
                  e(t.currentTarget)
                    .find(".easyzoom-flyout")
                    .removeClass("hidden");
                });
              }
              t.on("dragStart.flickity", function (e, t) {
                document.ontouchmove = function (e) {
                  e.preventDefault();
                };
              }),
                t.on("dragEnd.flickity", function (e, t) {
                  document.ontouchmove = function (e) {
                    return !0;
                  };
                }),
                t.find("a").on("click", function (e) {
                  e.preventDefault();
                }),
                n &&
                  "objectFit" in document.documentElement.style == !0 &&
                  (t.on("staticClick.flickity", function () {
                    "image" == t.find(".is-selected").attr("data-media-type") &&
                      t.flickity("toggleFullscreen");
                  }),
                  t.on("fullscreenChange.flickity", function (e, a) {
                    a
                      ? (t.parent().addClass("is-fullscreen"),
                        lazySizes.autoSizer.checkElems())
                      : t.parent().removeClass("is-fullscreen");
                  }));
            }
            var c = this.$container.find(".product-thumb--slider");
            if (c.length) {
              a = c.data("flickity-options");
              if ((o = c.data("slider-enabled"))) {
                r = (u = c.find("[data-initial-image]"))
                  .parent()
                  .find(".product-thumb--cell")
                  .index(u);
                (a.initialIndex = r),
                  u.removeAttr("data-initial-image"),
                  c.flickity(a);
                var d = c.data("flickity");
                (window.thumbFlkty = d),
                  c.find(".product-thumb--cell").on("keypress", function (a) {
                    "13" == (event.keyCode ? event.keyCode : event.which) &&
                      t.flickity("select", e(this).index());
                  }),
                  c.find(".product-thumb--cell").on("focus", function (t) {
                    var a = e(this).index(),
                      o = d.queryCell(a),
                      i = d.getCellSlideIndex(o),
                      n = d.slides[i].target;
                    (d.x = -n),
                      d.positionSlider(),
                      e(d.viewport)[0].scrollTo(0, 0);
                  }),
                  c.find("a").on("click", function (e) {
                    e.preventDefault();
                  }),
                  c.on("dragStart.flickity", function (e, t) {
                    document.ontouchmove = function (e) {
                      e.preventDefault();
                    };
                  }),
                  c.on("dragEnd.flickity", function (e, t) {
                    document.ontouchmove = function (e) {
                      return !0;
                    };
                  }),
                  c.find("button.flickity-button").attr("tabindex", "-1");
              } else {
                var u;
                (u = c.find("[data-initial-image]")).addClass(
                  "is-nav-selected"
                ),
                  u.removeAttr("data-initial-image"),
                  c.find(".product-thumb--cell").on("click", function (a) {
                    var o =
                      '[data-media-id="' + e(this).data("media-id") + '"]';
                    t.flickity("selectCell", o),
                      c.find(".is-nav-selected").removeClass("is-nav-selected"),
                      e(this).addClass("is-nav-selected"),
                      a.preventDefault();
                  }),
                  c.find("a").on("click", function (e) {
                    e.preventDefault();
                  }),
                  c.find(".product-thumb--cell").on("keypress", function (a) {
                    "13" == (event.keyCode ? event.keyCode : event.which) &&
                      (t.flickity("select", e(this).index()),
                      c.find(".is-nav-selected").removeClass("is-nav-selected"),
                      e(this).addClass("is-nav-selected"));
                  });
              }
              "objectFit" in document.documentElement.style == !1 &&
                c.find(".product-thumb--cell a").each(function () {
                  var t = e(this),
                    a = t.find("img").prop("src");
                  t.css({ "background-image": "url(" + a + ")" }),
                    t.addClass("fallback-object-fit");
                });
            }
            var p = this.$container.find(".thumbnails");
            if (
              p.length &&
              (p.find("a").on("click", function (a) {
                var o = e(this).data("media-id"),
                  i = '[data-media-id="' + o + '"]';
                t.flickity("selectCell", i),
                  p.find(".active").removeClass("active");
                var n = p.find('[data-media-id="' + o + '"]');
                n.addClass("active"),
                  p.find("[data-productthumbs]").height() > p.height() &&
                    p.data("enable-group") &&
                    p.is(":visible") &&
                    setTimeout(function () {
                      n.scrollIntoView();
                    }, 200),
                  a.preventDefault();
              }),
              p.data("enable-group"))
            ) {
              p.css({ "overflow-y": "scroll", position: "relative" }),
                t.resize(function () {
                  p.height(e(this).find(".flickity-viewport").height());
                });
              var h = p.find("[data-productthumbs]");
              setTimeout(function () {
                h.height() > p.height() && p.find("a.active").scrollIntoView();
              }, 200),
                p.find("li").each(function (t) {
                  e(this)
                    .delay(100 * t)
                    .fadeTo(200, 1);
                });
            }
          },
          _initProductVideo: function () {
            var t = this.settings.sectionId;
            e(this.selectors.productMediaTypeVideo, this.$container).each(
              function () {
                var a = e(this);
                theme.ProductVideo.init(a, t);
              }
            );
          },
          _initModelViewerLibraries: function () {
            var t = e(this.selectors.productMediaTypeModel, this.$container);
            t.length < 1 || theme.ProductModel.init(t, this.settings.sectionId);
          },
          _initShopifyXrLaunch: function () {
            var t = this;
            e(document).on("shopify_xr_launch", function () {
              e(
                t.selectors.productMediaWrapper +
                  ":not(." +
                  t.classes.hidden +
                  ")",
                t.$container
              ).trigger("xrLaunch");
            });
          },
          _linkOptionSelectors: function (t) {
            for (var a = 0; a < t.variants.length; a++) {
              var o = t.variants[a];
              if (o.available) {
                if (
                  ((this.optionsMap.root = this.optionsMap.root || []),
                  this.optionsMap.root.push(o.option1),
                  (this.optionsMap.root = e.unique(this.optionsMap.root)),
                  t.options.length > 1)
                ) {
                  var i = o.option1;
                  (this.optionsMap[i] = this.optionsMap[i] || []),
                    this.optionsMap[i].push(o.option2),
                    (this.optionsMap[i] = e.unique(this.optionsMap[i]));
                }
                if (3 === t.options.length) {
                  i = o.option1 + " / " + o.option2;
                  (this.optionsMap[i] = this.optionsMap[i] || []),
                    this.optionsMap[i].push(o.option3),
                    (this.optionsMap[i] = e.unique(this.optionsMap[i]));
                }
              }
            }
            this._updateOptionsInSelector(0),
              t.options.length > 1 && this._updateOptionsInSelector(1),
              3 === t.options.length && this._updateOptionsInSelector(2);
          },
          _updateOptionsInSelector: function (t) {
            switch (t) {
              case 0:
                var a = "root",
                  o = e(
                    ".single-option-radio:eq(0)",
                    this.selectors.addToCartForm
                  );
                break;
              case 1:
                (a = e(
                  "input:checked",
                  this.selectors.addToCartForm + " .single-option-radio:eq(0)"
                ).val()),
                  (o = e(
                    ".single-option-radio:eq(1)",
                    this.selectors.addToCartForm
                  ));
                break;
              case 2:
                a = e(
                  "input:checked",
                  this.selectors.addToCartForm + " .single-option-radio:eq(0)"
                ).val();
                a +=
                  " / " +
                  e(
                    "input:checked",
                    this.selectors.addToCartForm + " .single-option-radio:eq(1)"
                  ).val();
                o = e(
                  ".single-option-radio:eq(2)",
                  this.selectors.addToCartForm
                );
            }
            e("input:checked", o).val();
            var i = this.optionsMap[a],
              n = t + 1;
            e(
              '.radio-wrapper[data-option-index="' +
                n +
                '"] input.single-option-selector__radio',
              this.selectors.addToCartForm
            ).each(function () {
              -1 !== e.inArray(e(this).val(), i)
                ? e(this).parent().removeClass("soldout")
                : e(this).parent().addClass("soldout");
            });
            var r = e(
                '.radio-wrapper[data-option-index="' + n + '"]',
                this.selectors.addToCartForm
              ),
              s = r.find("input:checked").parent();
            if (
              s.hasClass("soldout") &&
              "true" == s.attr("data-variant-swatch-soldout")
            ) {
              var l = r.find(".swatch-container:not(.soldout)").eq(0);
              l.length > 0 && l.find("input").trigger("click");
            }
          },
          _updateAddToCart: function (t) {
            var a = t.variant,
              o = e(this.selectors.addToCartForm).data("dynamic-checkout");
            if (a)
              if (
                (e(this.selectors.cartError).hide(),
                e(this.selectors.productPrices)
                  .removeClass("visibility-hidden")
                  .attr("aria-hidden", "true"),
                a.available)
              ) {
                e(this.selectors.addToCart)
                  .removeClass("disabled")
                  .prop("disabled", !1);
                var i = StyleHatch.Strings.addToCart;
                e(this.selectors.addToCart)[0].hasAttribute("data-preorder") &&
                  (i = StyleHatch.Strings.preOrder),
                  e(this.selectors.addToCartText).text(i),
                  e(this.selectors.quantityWrap).show(),
                  o &&
                    e(this.selectors.cartButtons).addClass(
                      "cart-buttons__enabled"
                    );
              } else
                e(this.selectors.addToCart)
                  .addClass("disabled")
                  .prop("disabled", !0),
                  e(this.selectors.addToCartText).text(
                    StyleHatch.Strings.soldOut
                  ),
                  e(this.selectors.quantityWrap).hide(),
                  o &&
                    e(this.selectors.cartButtons).removeClass(
                      "cart-buttons__enabled"
                    );
            else
              e(this.selectors.addToCart)
                .addClass("disabled")
                .prop("disabled", !0),
                e(this.selectors.addToCartText).text(
                  StyleHatch.Strings.soldOut
                ),
                e(this.selectors.productPrices)
                  .addClass("visibility-hidden")
                  .attr("aria-hidden", "false"),
                e(this.selectors.quantityWrap).hide(),
                o &&
                  e(this.selectors.cartButtons).removeClass(
                    "cart-buttons__enabled"
                  );
          },
          _updateSwatches: function (t) {
            var a = t.variant,
              o =
                (e(t.currentTarget).find("[type=radio]"),
                e(t.currentTarget).find(".radio-wrapper"));
            this._updateOptionsInSelector(0),
              this.productSingleObject.options.length > 1 &&
                this._updateOptionsInSelector(1),
              3 === this.productSingleObject.options.length &&
                this._updateOptionsInSelector(2),
              o.each(function () {
                var t = e(this),
                  o = "option" + t.data("option-index"),
                  i = t.find(".single-option-radio__label--value");
                if (i.length && a) {
                  var n = a[o];
                  i.text(n);
                }
              });
          },
          _updateImages: function (t) {
            var a = t.variant;
            theme.Images.getSizedImageUrl(
              a.featured_image.src,
              this.settings.imageSize
            );
            this.settings.zoomEnabled &&
              theme.Images.getSizedImageUrl(
                a.featured_image.src,
                this.settings.imageZoomSize
              );
            e(
              this.selectors.productThumbImages +
                '[data-image-id="' +
                a.featured_image.id +
                '"]'
            );
            var o = this.$container.find(".product-image--slider");
            if (o.length) {
              var i = '[data-image-id="' + a.featured_media.id + '"]';
              o.flickity("selectCell", i, !1, !0);
            }
          },
          _updateAvailability: function (e) {
            e.variant &&
              (this._updateStoreAvailabilityContent(e), this._updatePrice(e)),
              this._updateAddToCart(e);
          },
          _updateStoreAvailabilityContent: function (e) {
            this.storeAvailability &&
              e.variant &&
              this.storeAvailability.updateContent(
                e.variant.id,
                this.productSingleObject.title
              );
          },
          _updatePrice: function (t) {
            var a = t.variant,
              o = e(this.selectors.priceContainer, this.$container),
              i = e(this.selectors.unitPrice, o),
              n = e(this.selectors.unitPriceBaseUnit, o);
            if (
              (e(this.selectors.originalPrice).html(
                theme.Currency.formatMoney(a.price, StyleHatch.currencyFormat)
              ),
              a.compare_at_price > a.price)
            ) {
              e(this.selectors.comparePrice)
                .find("span.money")
                .html(
                  theme.Currency.formatMoney(
                    a.compare_at_price,
                    StyleHatch.currencyFormat
                  )
                ),
                e(this.selectors.comparePrice).css("display", "inline");
              var r = Math.round(
                  (100 * (a.compare_at_price - a.price)) / a.compare_at_price
                ),
                s = a.compare_at_price - a.price;
              e(this.selectors.savings)
                .find("span.savings--percentage")
                .html(r + "%"),
                e(this.selectors.savings)
                  .find("span.savings--amount")
                  .html(
                    theme.Currency.formatMoney(s, StyleHatch.currencyFormat)
                  ),
                e(this.selectors.savings).show();
            } else
              e(this.selectors.comparePrice).hide(),
                e(this.selectors.savings).hide();
            a.unit_price &&
              (i.html(
                theme.Currency.formatMoney(
                  a.unit_price,
                  StyleHatch.currencyFormat
                )
              ),
              n.html(slate.utils.getBaseUnit(a)),
              o.addClass(this.classes.productUnitAvailable));
          },
          _updateSKU: function (t) {
            var a = t.variant;
            e(this.selectors.SKU).html(a.sku);
          },
          onUnload: function () {
            this.$container.off(this.settings.namespace),
              theme.ProductVideo.removeSectionVideos(this.settings.sectionId),
              theme.ProductModel.removeSectionModels(this.settings.sectionId),
              e.magnificPopup.close(),
              this.settings.zoomEnabled &&
                e(this.selectors.productImageWrap)
                  .easyZoom()
                  .data("easyZoom")
                  .teardown(),
              StyleHatch.ajaxCartEnable && StyleHatch.AjaxCart.unload(),
              this.$container.destroyProductBox();
          },
        })),
        t
      );
    })()),
    (StyleHatch.ProductRecommendations = (function () {
      function t(t) {
        var a = (this.$container = e(t)),
          o = a.data("productId"),
          i = a.data("limit"),
          n =
            StyleHatch.routes.product_recommendations_url +
            "?&section_id=product-recommendations&limit=" +
            i +
            "&product_id=" +
            o;
        a.parent().load(n + " .product-recommendations", function () {
          e(this).productBox();
        });
      }
      return (
        (t.prototype = e.extend({}, t.prototype, {
          onUnload: function () {
            this.$container.destroyProductBox();
          },
        })),
        t
      );
    })()),
    (StyleHatch.Collection = (function () {
      var t = "sort_by",
        a = "title-ascending",
        o = "#SortBy",
        i = ".sort-by__default-sort",
        n = ".change-view",
        r = ".advanced-filter a",
        s = ".mobile-aside-container > a.button.simple",
        l = ".mobile-aside-container aside",
        c = ".box.product .image-table",
        d = "ul.nested-menu";
      function u(t) {
        var a = (this.$container = e(t));
        a.attr("data-section-id");
        (this.$sortSelect = e(o, a)),
          (this.defaultSort = this._getDefaultSortValue()),
          (this.$viewButton = e(n)),
          this.$sortSelect.on("change", this._onSortChange.bind(this)),
          this.$viewButton.on("click", this._onViewChange),
          (this.$productbox = e(c, a)),
          this._initSidebar(),
          this._initAdvancedTags(),
          a.productBox();
      }
      return (
        (u.prototype = e.extend({}, u.prototype, {
          _onSortChange: function (a) {
            var o = "";
            (this.sort = this._getSortValue()),
              this.sort !== this.defaultSort && ((o = {})[t] = this.sort),
              (window.location.search = decodeURIComponent(e.param(o)));
          },
          _getSortValue: function () {
            return this.$sortSelect.val() || this.defaultSort;
          },
          _getDefaultSortValue: function () {
            return e(i, this.$container).val() || a;
          },
          _onViewChange: function (t) {
            var a = e(this).data("view"),
              o = document.URL,
              i = o.indexOf("?") > -1;
            (window.location = i
              ? replaceUrlParam(o, "view", a)
              : o + "?view=" + a),
              t.preventDefault();
          },
          _initSidebar: function () {
            e(s).on("click", function (t) {
              e(l).slideToggle(), t.preventDefault();
            }),
              this.$container.find(d).initNestedMenu();
          },
          _initAdvancedTags: function () {
            var t, a, o, i;
            e(r).on("click", function (n) {
              if (
                ((t = e(this).parent()),
                (a = t.data("group")),
                (o = t.data("handle")),
                (i = e('.active[data-group="' + a + '"]')),
                !t.hasClass("active") && i.length > 0)
              ) {
                n.preventDefault();
                var r = window.location.pathname
                  .replace(i.data("handle"), o)
                  .replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, "");
                window.location.pathname = r;
              }
            });
          },
          onUnload: function () {
            this.$sortSelect.off("change"),
              this.$viewButton.off("click"),
              e(r).off("click"),
              this.$container.destroyProductBox(),
              this.$container.find(d).destroyNestedMenu();
          },
        })),
        u
      );
    })()),
    (StyleHatch.ListCollections = (function () {
      var t = ".box .image-table";
      function a(a) {
        var o = (this.$container = e(a)),
          i = (o.attr("data-section-id"), o.data("layout"));
        o.find(".card__image");
        (this.$productbox = e(t, o)), "preview" == i && o.productBox();
      }
      return (
        (a.prototype = e.extend({}, a.prototype, {
          onUnload: function () {
            $container.destroyProductBox();
          },
        })),
        a
      );
    })()),
    (StyleHatch.BlogArticle = (function () {
      var t = ".mobile-aside-container > a.button.simple",
        a = ".mobile-aside-container aside",
        o = "ul.nested-menu";
      function i(t) {
        (this.$container = e(t)).attr("data-section-id");
        this._initSidebar(), StyleHatch.videoLayout();
      }
      return (
        (i.prototype = e.extend({}, i.prototype, {
          _initSidebar: function () {
            e(t).on("click", function (t) {
              e(a).slideToggle(), t.preventDefault();
            }),
              this.$container.find(o).initNestedMenu();
          },
          onUnload: function () {
            e(t).off("click"), this.$container.find(o).destroyNestedMenu();
          },
        })),
        i
      );
    })()),
    (StyleHatch.Password = (function () {
      function t(t) {
        (this.$container = e(t)).attr("data-section-id");
        var a = e("#login_form");
        e(".login-popup").magnificPopup({
          type: "inline",
          midClick: !0,
          mainClass: "mfp-fade",
          closeBtnInside: !1,
          callbacks: {
            afterClose: function () {
              e("a").blur(), a.find(".errors").remove();
            },
          },
        }),
          e("#mc-embedded-subscribe-form").on("submit", function () {
            e("p.signup-message").hide(),
              e("p.thanks-message").show(),
              e(this).find(".input-row").hide();
          }),
          a.find(".errors").length > 0 &&
            e(".login-popup").magnificPopup("open");
      }
      return (
        (t.prototype = e.extend({}, t.prototype, {
          onUnload: function () {
            e.magnificPopup.close(),
              e("#mc-embedded-subscribe-form").off("submit");
          },
        })),
        t
      );
    })()),
    (StyleHatch.Cart = (function () {
      function t(t) {
        var a = (this.$container = e(t)),
          o = (a.attr("data-section-id"), a.data("ajax-cart"));
        if ((StyleHatch.quantitySelect(), o)) {
          function i(t) {
            var a = t,
              o = (a.attr("data-cart-item"), e("[data-cart-item-quantity]", a)),
              i = e("[data-cart-item-quantity-minus]", a),
              n = e("[data-cart-item-quantity-plus]", a),
              r = e("[data-cart-item-remove]", a);
            o.on("blur", function (t) {
              t.preventDefault();
              var a = e(this).val(),
                o = e(this).closest(".cart-item"),
                i = o.attr("data-cart-item");
              o.addClass("cart-item--pending"),
                e(".cart-checkout").addClass("cart-checkout--pending"),
                CartJS.updateItemById(i, a);
            }),
              o.on("keypress", function (t) {
                if (13 === t.which) {
                  t.preventDefault();
                  var a = e(this).val(),
                    o = e(this).closest(".cart-item"),
                    i = o.attr("data-cart-item");
                  o.addClass("cart-item--pending"),
                    e(".cart-checkout").addClass("cart-checkout--pending"),
                    CartJS.updateItemById(i, a);
                }
              }),
              i.on("click", function (t) {
                t.preventDefault();
                var a = o.val(),
                  i = e(this).closest(".cart-item"),
                  n = i.attr("data-cart-item");
                i.addClass("cart-item--pending"),
                  e(".cart-checkout").addClass("cart-checkout--pending"),
                  CartJS.updateItemById(n, a),
                  0 == a && i.attr("data-cart-item", "").remove();
              }),
              n.on("click", function (t) {
                t.preventDefault();
                var a = o.val(),
                  i = e(this).closest(".cart-item"),
                  n = i.attr("data-cart-item");
                i.addClass("cart-item--pending"),
                  e(".cart-checkout").addClass("cart-checkout--pending"),
                  CartJS.updateItemById(n, a);
              }),
              r.on("click", function (t) {
                t.preventDefault();
                var a = e(this).closest(".cart-item"),
                  o = a.attr("data-cart-item");
                e(".cart-checkout").addClass("cart-checkout--pending"),
                  a.attr("data-cart-item", "").remove(),
                  CartJS.removeItemById(o);
              });
          }
          CartJS.init(StyleHatch.cartData),
            e("[data-cart-item]", a).each(function () {
              i(e(this));
            }),
            e(document).on("cart.requestComplete", function (t, o) {
              StyleHatch.AjaxCart.updateCartButton(o),
                window.Shopify &&
                  Shopify.StorefrontExpressButtons &&
                  Shopify.StorefrontExpressButtons.initialize(),
                e(".cart-item--pending").removeClass("cart-item--pending"),
                e(".cart-checkout--pending").removeClass(
                  "cart-checkout--pending"
                );
              var n = [],
                r = e("[data-cart-item]", a).first();
              e.each(o.items, function (t, o) {
                var s = o.key,
                  l = o.quantity,
                  c =
                    (theme.Currency.formatMoney(
                      o.price,
                      StyleHatch.currencyFormat
                    ),
                    theme.Currency.formatMoney(
                      o.line_price,
                      StyleHatch.currencyFormat
                    ),
                    e('[data-cart-item="' + s + '"]'));
                if (0 === c.length) {
                  var d = e("[data-cart-item]", a).first().clone();
                  if (0 === t) var u = d.insertAfter(e(".label-row", a));
                  else u = d.insertAfter(r);
                  u.attr("data-cart-item", o.key);
                  var p = theme.Images.getSizedImageUrl(o.image, "394x");
                  e("[data-cart-item-image]", u)
                    .attr("src", p)
                    .removeAttr("class")
                    .removeAttr("data-widths")
                    .removeAttr("data-aspectratio")
                    .removeAttr("data-sizes")
                    .removeAttr("data-srcset")
                    .removeAttr("sizes")
                    .removeAttr("srcset"),
                    e("[data-cart-item-image]", u)
                      .parent()
                      .removeAttr("class")
                      .removeAttr("style"),
                    e("[data-cart-item-title]", u).html(o.product_title),
                    e("[data-cart-item-href]", u).attr("href", o.url),
                    e("[data-cart-item-vendor]", u).html(o.vendor),
                    e("[data-cart-item-variant-title]", u).html(
                      o.variant_title
                    ),
                    e("[data-cart-item-quantity]", u)
                      .val(o.quantity)
                      .attr("id", "updates_" + o.key),
                    u
                      .find(".quantity-select")
                      .removeAttr("data-quantity-select-enabled"),
                    StyleHatch.quantitySelect(),
                    i(u),
                    (c = u);
                }
                e("[data-cart-item-quantity]", c).val(l),
                  (function (t, a) {
                    var o = theme.Currency.formatMoney(
                        a.final_price,
                        StyleHatch.currencyFormat
                      ),
                      i = theme.Currency.formatMoney(
                        a.original_price,
                        StyleHatch.currencyFormat
                      ),
                      n =
                        '<p><span class="money final-price" data-cart-item-final-price>' +
                        o +
                        "</span></p>",
                      r = e(".cart-item-price", t).html(n),
                      s = theme.Currency.formatMoney(
                        a.final_line_price,
                        StyleHatch.currencyFormat
                      ),
                      l = e(".cart-item-total", t).attr("data-mobile-label");
                    if (
                      (e(".cart-item-total", t).html(
                        '<div class="mobile-label">' +
                          l +
                          '</div><p><span class="money" data-cart-item-line-price>' +
                          s +
                          "</span></p>"
                      ),
                      a.final_price < a.original_price)
                    ) {
                      if (
                        (e(".final-price", r).addClass("final-price-discount"),
                        e(".cart-item-price", t).append(
                          '<p><span class="money original-price" data-cart-item-original-price>' +
                            i +
                            "</p>"
                        ),
                        a.discounts.length > 0)
                      ) {
                        e(".cart-item-price", t).append(
                          '<ul class="cart-item-discounts"></ul>'
                        );
                        var c = e(".cart-item-discounts", t);
                        e.each(a.discounts, function (e, t) {
                          var a = t.title,
                            o = theme.Currency.formatMoney(
                              t.amount,
                              StyleHatch.currencyFormat
                            );
                          c.append(
                            '<li class="cart-item-discount"><span class="cart-item-discount-title">' +
                              a +
                              '</span><br><span class="cart-item-discount-amount">(-<span class="money">' +
                              o +
                              "</span>)</span></li>"
                          );
                        });
                      }
                      var d = theme.Currency.formatMoney(
                        a.original_line_price,
                        StyleHatch.currencyFormat
                      );
                      e(".cart-item-total", t).append(
                        '<p><span class="money original-price" data-cart-item-original-price>' +
                          d +
                          "</span></p>"
                      );
                    }
                    if (a.unit_price) {
                      var u = theme.Currency.formatMoney(
                          a.unit_price,
                          StyleHatch.currencyFormat
                        ),
                        p = slate.utils.getBaseUnit(a),
                        h =
                          '<div data-unit-price-group><dt><span class="visually-hidden visually-hidden--inline">' +
                          StyleHatch.Strings.unitPrice +
                          '</span></dt><dd><span class="price-unit-price"><span data-unit-price="">' +
                          u +
                          '</span><span aria-hidden="true">/</span><span class="visually-hidden">' +
                          StyleHatch.Strings.unitPriceSeparator +
                          '&nbsp;</span><span data-unit-price-base-unit="">' +
                          p +
                          "</span></span></dd></div>";
                      e(".cart-item-price", t).append(h);
                    }
                  })(c, o),
                  n.push(s),
                  (r = c);
              }),
                e("[data-cart-item]", a).each(function (t) {
                  var a = e(this).attr("data-cart-item");
                  -1 === e.inArray(a, n) && e(this).remove();
                });
              var s = theme.Currency.formatMoney(
                  o.total_price,
                  StyleHatch.currencyFormat
                ),
                l = e("[data-cart-subtotal]");
              if (
                (l.removeClass("money"),
                l.html('<span class="money">' + s + "</span>"),
                o.cart_level_discount_applications.length > 0)
              ) {
                0 === e(".cart-discount").length &&
                  e(".cart-checkout").prepend(
                    '<ul class="cart-discount"></ul>'
                  );
                var c = e(".cart-discount");
                c.show(),
                  c.empty(),
                  e.each(o.cart_level_discount_applications, function (e, t) {
                    var a = theme.Currency.formatMoney(
                      t.total_allocated_amount,
                      StyleHatch.currencyFormat
                    );
                    c.append(
                      '<li class="cart-discount--applications"><span class="cart-discount--title">' +
                        t.title +
                        '</span><span class="cart-discount--amount">-<span class="money">' +
                        a +
                        "</span></span></li>"
                    );
                  });
              } else e(".cart-discount").hide();
              e(".cart-discount--title").html(
                o.cart_level_discount_applications.title
              );
            });
        }
        var n = e(".terms-and-conditions", a);
        n.length > 0 &&
          (e("body").on(
            "click",
            '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
            function () {
              if (!e("#terms-and-conditions__agree").is(":checked"))
                return (
                  e(".terms-and-conditions__notice").length <= 0 &&
                    n.append(
                      '<div class="terms-and-conditions__notice"><p><em>' +
                        StyleHatch.Strings.agreeNotice +
                        "</em></p></div>"
                    ),
                  !1
                );
              e(this).submit();
            }
          ),
          n.find("input").on("click", function () {
            n.find(".terms-and-conditions__notice").remove();
          }));
      }
      return (
        (t.prototype = e.extend({}, t.prototype, { onUnload: function () {} })),
        t
      );
    })()),
    (StyleHatch.AjaxCart = (function () {
      var t = "body",
        a = "header.util",
        o = "header.util .cart-preview",
        i = "[data-AddToCartForm] > form",
        n = "[data-AddToCartForm]",
        r = "[data-CartButton]",
        s = "#CartCount",
        l = "#CartCost",
        c = {
          addURL: StyleHatch.routes.cart_add_url + ".js",
          cartURL: StyleHatch.routes.cart_url + ".js",
          clearURL: StyleHatch.routes.cart_clear_url + ".js",
        },
        d = {};
      function u(e) {
        d.$cartButton;
        var t = d.$cartCount,
          a = d.$cartCost,
          o = e.item_count,
          i = theme.Currency.formatMoney(
            e.total_price,
            StyleHatch.currencyFormat
          );
        t.text(o),
          a.removeClass("money"),
          a.html('<span class="money">' + i + "</span>");
      }
      return {
        init: function () {
          (d = {
            $body: e(t),
            $util: e(a),
            $cartPreview: e(o),
            $addToCartForm: e(i),
            $addToCartButton: e(n),
            $cartButton: e(r),
            $cartCount: e(s),
            $cartCost: e(l),
          }),
            StyleHatch.ajaxCartEnable &&
              d.$addToCartForm.each(function () {
                e(this).on("submit", function (t) {
                  !(function (t) {
                    var a = (t = t).find(".cart-error"),
                      o = t.find("[data-AddToCartText]").html(),
                      i =
                        (t.find("[data-AddToCartText]").attr("data-added"),
                        t.find("[data-AddToCartText]").attr("data-adding"));
                    t
                      .find("[data-AddToCart]")
                      .addClass("added")
                      .prop("disabled", !0),
                      t.find("[data-AddToCartText]").html(i),
                      a.hide(),
                      e
                        .post(
                          c.addURL,
                          t.serialize(),
                          function (a) {
                            var i = a;
                            e.get(
                              c.cartURL,
                              function (a) {
                                var n = a;
                                u(n),
                                  (function (t, a) {
                                    var o = d.$util,
                                      i = d.$cartPreview;
                                    clearTimeout(d.hideCartPreview),
                                      d.$cartPreview.hide();
                                    var n = a.item_count,
                                      r = theme.Currency.formatMoney(
                                        a.total_price,
                                        StyleHatch.currencyFormat
                                      ),
                                      s = (t = JSON.parse(t)).product_title,
                                      l = t.variant_options,
                                      c = t.image,
                                      u = t.url,
                                      p = theme.Currency.formatMoney(
                                        t.price,
                                        StyleHatch.currencyFormat
                                      ),
                                      h =
                                        (t.quantity,
                                        theme.Currency.formatMoney(
                                          t.line_price,
                                          StyleHatch.currencyFormat
                                        ),
                                        t.selling_plan_allocation
                                          ? t.selling_plan_allocation
                                              .selling_plan.name
                                          : null);
                                    h &&
                                      i
                                        .find(".product-selling-plan")
                                        .empty()
                                        .append(h);
                                    var f = t.properties;
                                    if (f && Object.keys(f).length > 0) {
                                      var m = i
                                        .find(".product-options")
                                        .empty();
                                      for (const e in f) {
                                        var y = e,
                                          v = f[e];
                                        y.startsWith("_") ||
                                          "" == v ||
                                          m.append(
                                            `<li><strong>${y}:</strong> ${v}</li>`
                                          );
                                      }
                                    }
                                    if (t.unit_price)
                                      var g = theme.Currency.formatMoney(
                                          t.unit_price,
                                          StyleHatch.currencyFormat
                                        ),
                                        b = slate.utils.getBaseUnit(t);
                                    var w = i.find(".product-image").empty();
                                    w.append(
                                      '<img src="' + c + '" alt="' + s + '">'
                                    ),
                                      w.attr("href", u);
                                    var S = i.find(".product-title");
                                    S.html(s), S.attr("href", u);
                                    var T = i.find(".product-variant").empty();
                                    e.each(l, function () {
                                      this.toLowerCase().indexOf(
                                        "default title"
                                      ) < 0
                                        ? (T.show(),
                                          T.append("<li>" + this + "</li>"))
                                        : T.hide();
                                    });
                                    var _ = i.find(".product-price");
                                    if (
                                      (_.removeClass("money"),
                                      _.html(
                                        '<strong><span class="money">' +
                                          p +
                                          "</span></strong>"
                                      ),
                                      g &&
                                        _.append(
                                          '&nbsp;<span class="unit-price">' +
                                            g +
                                            "/" +
                                            b +
                                            "</span>"
                                        ),
                                      i.find(".item-count").text(n),
                                      n > 1
                                        ? (i.find(".count.plural").show(),
                                          i.find(".count.singular").hide())
                                        : (i.find(".count.plural").hide(),
                                          i.find(".count.singular").show()),
                                      a.cart_level_discount_applications
                                        .length > 0)
                                    ) {
                                      var k = e(".cart-preview--discounts");
                                      k.show(),
                                        k.empty(),
                                        e.each(
                                          a.cart_level_discount_applications,
                                          function (e, t) {
                                            var a = theme.Currency.formatMoney(
                                              t.total_allocated_amount,
                                              StyleHatch.currencyFormat
                                            );
                                            k.append(
                                              '<li class="cart-discount--applications"><span class="cart-discount--title">' +
                                                t.title +
                                                '</span><span class="cart-discount--amount">-<span class="money">' +
                                                a +
                                                "</span></span></li>"
                                            );
                                          }
                                        );
                                    } else e(".cart-preview--discounts").hide();
                                    i.find(".total-price").html(
                                      '<span class="money">' + r + "</span>"
                                    );
                                    var C = o.height();
                                    i.css({ top: C }),
                                      i.fadeIn(300),
                                      (d.hideCartPreview = setTimeout(
                                        function () {
                                          i.fadeOut(300);
                                        },
                                        6e3
                                      )),
                                      i
                                        .find("a.continue-shopping")
                                        .on("click", function (e) {
                                          i.fadeOut(300), e.preventDefault();
                                        });
                                  })(i, n),
                                  setTimeout(function () {
                                    t
                                      .find("[data-AddToCart]")
                                      .removeClass("added")
                                      .prop("disabled", !1),
                                      t.find("[data-AddToCartText]").html(o);
                                  }, 500);
                              },
                              "json"
                            );
                          },
                          "text"
                        )
                        .fail(function (e) {
                          if (void 0 !== e && void 0 !== e.status) {
                            var i = JSON.parse(e.responseText);
                            a.html(
                              "<strong>" +
                                i.message +
                                ":</strong> <em>" +
                                i.description +
                                "<em>"
                            ),
                              a.slideDown();
                          }
                          setTimeout(function () {
                            t
                              .find("[data-AddToCart]")
                              .removeClass("added")
                              .prop("disabled", !1),
                              t.find("[data-AddToCartText]").html(o);
                          }, 500);
                        });
                  })(e(this)),
                    t.preventDefault();
                });
              });
        },
        clearCart: function () {
          e.post(c.clearURL);
        },
        updateCartButton: u,
        unload: function () {
          d.$addToCartForm.off("submit"),
            clearTimeout(d.hideCartPreview),
            d.$cartPreview.hide();
        },
      };
    })()),
    (window.theme = window.theme || {}),
    (window.slate = window.slate || {}),
    (slate.a11y = {
      pageLinkFocus: function (e) {
        e.first()
          .attr("tabIndex", "-1")
          .focus()
          .addClass("js-focus-hidden")
          .one("blur", function () {
            e.first().removeClass("js-focus-hidden").removeAttr("tabindex");
          });
      },
      focusHash: function () {
        var t = window.location.hash;
        t && document.getElementById(t.slice(1)) && this.pageLinkFocus(e(t));
      },
      bindInPageLinks: function () {
        e("a[href*=#]").on(
          "click",
          function (t) {
            this.pageLinkFocus(e(t.currentTarget.hash));
          }.bind(this)
        );
      },
      trapFocus: function (t) {
        var a = {
            focusin: t.namespace ? "focusin." + t.namespace : "focusin",
            focusout: t.namespace ? "focusout." + t.namespace : "focusout",
            keydown: t.namespace
              ? "keydown." + t.namespace
              : "keydown.handleFocus",
          },
          o = t.$container.find(
            e(
              'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            ).filter(":visible")
          ),
          i = o[0],
          n = o[o.length - 1];
        t.$elementToFocus || (t.$elementToFocus = t.$container),
          t.$container.attr("tabindex", "-1"),
          t.$elementToFocus.focus(),
          e(document).off("focusin"),
          e(document).on(a.focusout, function () {
            e(document).off(a.keydown);
          }),
          e(document).on(a.focusin, function (t) {
            (t.target !== n && t.target !== i) ||
              e(document).on(a.keydown, function (e) {
                !(function (e) {
                  9 === e.keyCode &&
                    (e.target !== n ||
                      e.shiftKey ||
                      (e.preventDefault(), i.focus()),
                    e.target === i &&
                      e.shiftKey &&
                      (e.preventDefault(), n.focus()));
                })(e);
              });
          });
      },
      removeTrapFocus: function (t) {
        var a = t.namespace ? "focusin." + t.namespace : "focusin";
        t.$container &&
          t.$container.length &&
          t.$container.removeAttr("tabindex"),
          e(document).off(a);
      },
      accessibleLinks: function (t) {
        var a = document.querySelector("body"),
          o = {
            newWindow: "a11y-new-window-message",
            external: "a11y-external-message",
            newWindowExternal: "a11y-new-window-external-message",
          };
        (void 0 !== t.$links && t.$links.jquery) ||
          (t.$links = e("a[href]:not([aria-describedby])")),
          e.each(t.$links, function () {
            var t = e(this),
              a = t.attr("target"),
              i = t.attr("rel"),
              n = (function (e) {
                var t = window.location.hostname;
                return e[0].hostname !== t;
              })(t),
              r = "_blank" === a;
            n && t.attr("aria-describedby", o.external),
              r &&
                ((void 0 !== i && -1 !== i.indexOf("noopener")) ||
                  t.attr("rel", function (e, t) {
                    return (void 0 === t ? "" : t + " ") + "noopener";
                  }),
                t.attr("aria-describedby", o.newWindow)),
              n && r && t.attr("aria-describedby", o.newWindowExternal);
          }),
          (function (t) {
            "object" != typeof t && (t = {});
            var i = e.extend(
                {
                  newWindow: "Opens in a new window.",
                  external: "Opens external website.",
                  newWindowExternal: "Opens external website in a new window.",
                },
                t
              ),
              n = document.createElement("ul"),
              r = "";
            for (var s in i) r += "<li id=" + o[s] + ">" + i[s] + "</li>";
            n.setAttribute("hidden", !0), (n.innerHTML = r), a.appendChild(n);
          })(t.messages);
      },
    }),
    (theme.StoreAvailability = (function () {
      var e = "[data-store-availability-modal-open]",
        t = "[data-store-availability-modal-product-title]";
      function a(e) {
        (this.container = e),
          (this.eventHandlers = {}),
          (this.eventHandlers.debounceResize = theme.Helpers.debounce(
            function () {
              this._handleResize();
            }.bind(this),
            500
          )),
          window.addEventListener("resize", this.eventHandlers.debounceResize);
      }
      return (
        (a.prototype = Object.assign({}, a.prototype, {
          updateContent: function (t, a) {
            var o = "/variants/" + t + "/?section_id=store-availability";
            this.container.innerHTML = "";
            var i = this;
            fetch(o)
              .then(function (e) {
                return e.text();
              })
              .then(function (t) {
                "" !== t.trim() &&
                  ((i.container.innerHTML = t),
                  (i.container.innerHTML =
                    i.container.firstElementChild.innerHTML),
                  i.container.querySelector(e) &&
                    ((i.modal = i._initModal()),
                    i._updateProductTitle(a),
                    i._handleResize()));
              });
          },
          _initModal: function () {
            return new window.Modals(
              "StoreAvailabilityModal",
              "store-availability-modal",
              {
                close: ".js-modal-close-store-availability-modal",
                closeModalOnClick: !0,
                openClass: "store-availabilities-modal--active",
                scrollIntoView: !0,
              }
            );
          },
          _updateProductTitle: function (e) {
            this.container.querySelector(t).textContent = e;
          },
          _handleResize: function () {
            (this.modal && !this.modal.modalIsOpen) ||
              this.modal.scrollIntoView();
          },
        })),
        a
      );
    })()),
    (window.Modals = (function () {
      function t(e, t, a) {
        var o = {
          close: ".js-modal-close",
          open: ".js-modal-open-" + t,
          openClass: "modal--is-active",
          closeModalOnClick: !1,
          scrollIntoView: !1,
        };
        if (((this.modal = document.getElementById(e)), !this.modal)) return !1;
        (this.nodes = {
          parents: [document.querySelector("html"), document.body],
        }),
          (this.config = Object.assign(o, a)),
          (this.modalIsOpen = !1),
          (this.focusOnOpen = this.config.focusOnOpen
            ? document.getElementById(this.config.focusOnOpen)
            : this.modal),
          this.init();
      }
      return (
        (t.prototype.init = function () {
          document
            .querySelector(this.config.open)
            .addEventListener("click", this.open.bind(this)),
            this.modal
              .querySelector(this.config.close)
              .addEventListener("click", this.closeModal.bind(this));
        }),
        (t.prototype.open = function (t) {
          var a = this,
            o = !1;
          this.modalIsOpen ||
            ((this.$container = e(this.modal).parent()),
            this.$container.append('<div class="mobile-menu-overlay"></div>'),
            (this.$overlay = this.$container.find(".mobile-menu-overlay")),
            this.$overlay.show().css({ opacity: 0.6, "z-index": 999 }),
            t ? t.preventDefault() : (o = !0),
            t && t.stopPropagation && t.stopPropagation(),
            this.modalIsOpen && !o && this.closeModal(),
            this.modal.classList.add(this.config.openClass),
            this.nodes.parents.forEach(function (e) {
              e.classList.add(a.config.openClass);
            }),
            (this.modalIsOpen = !0),
            slate.a11y.trapFocus({
              $container: e(this.modal),
              $elementToFocus: this.focusOnOpen,
            }),
            this.config.scrollIntoView && this.scrollIntoView(),
            this.bindEvents());
        }),
        (t.prototype.closeModal = function () {
          if (this.modalIsOpen) {
            document.activeElement.blur(),
              this.modal.classList.remove(this.config.openClass);
            var t = this;
            this.nodes.parents.forEach(function (e) {
              e.classList.remove(t.config.openClass);
            }),
              this.$overlay.remove(),
              (this.modalIsOpen = !1),
              slate.a11y.removeTrapFocus({ $container: e(this.modal) }),
              this.unbindEvents();
          }
        }),
        (t.prototype.bindEvents = function () {
          (this.keyupHandler = this.keyupHandler.bind(this)),
            (this.clickHandler = this.clickHandler.bind(this)),
            document.body.addEventListener("keyup", this.keyupHandler),
            document.body.addEventListener("click", this.clickHandler);
        }),
        (t.prototype.unbindEvents = function () {
          document.body.removeEventListener("keyup", this.keyupHandler),
            document.body.removeEventListener("click", this.clickHandler);
        }),
        (t.prototype.keyupHandler = function (e) {
          27 === e.keyCode && this.closeModal();
        }),
        (t.prototype.clickHandler = function (e) {
          this.config.closeModalOnClick &&
            !this.modal.contains(e.target) &&
            this.closeModal();
        }),
        (t.prototype.scrollIntoView = function () {
          this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
        }),
        t
      );
    })()),
    (theme.Images = {
      preload: function (e, t) {
        "string" == typeof e && (e = [e]);
        for (var a = 0; a < e.length; a++) {
          var o = e[a];
          this.loadImage(this.getSizedImageUrl(o, t));
        }
      },
      loadImage: function (e) {
        new Image().src = e;
      },
      switchImage: function (e, t, a) {
        var o = this.imageSize(t.src),
          i = this.getSizedImageUrl(e.src, o);
        a ? a(i, e, t) : (t.src = i);
      },
      imageSize: function (e) {
        var t = e.match(
          /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
        );
        return null !== t ? t[1] : null;
      },
      getSizedImageUrl: function (e, t) {
        if (null == t) return e;
        if ("master" === t) return this.removeProtocol(e);
        var a = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null != a) {
          var o = e.split(a[0]),
            i = a[0];
          return this.removeProtocol(o[0] + "_" + t + i);
        }
        return null;
      },
      removeProtocol: function (e) {
        return e.replace(/http(s)?:/, "");
      },
    }),
    (window.onYouTubeIframeAPIReady = function () {
      theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
    }),
    (theme.ProductVideo = (function () {
      var e = {},
        t = { html5: "html5", youtube: "youtube" },
        a = "[data-product-single-media-wrapper]",
        o = "enable-video-looping",
        i = "video-id";
      function n(a) {
        a
          ? (function () {
              for (var a in e)
                if (e.hasOwnProperty(a)) {
                  var o = e[a];
                  if (o.nativeVideo) continue;
                  o.host === t.html5 &&
                    (o.element.setAttribute("controls", "controls"),
                    (o.nativeVideo = !0));
                }
            })()
          : s(t.html5);
      }
      function r(e) {
        return "VIDEO" === e.tagName
          ? t.html5
          : "IFRAME" === e.tagName &&
            /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
              e.src
            )
          ? t.youtube
          : null;
      }
      function s(t) {
        for (var a in e)
          if (e.hasOwnProperty(a)) {
            var o = e[a];
            o.host === t && o.ready();
          }
      }
      return {
        init: function (s, l) {
          if (s.length) {
            var c = s.find("iframe, video")[0],
              d = s.data("mediaId");
            if (c)
              switch (
                ((e[d] = {
                  mediaId: d,
                  sectionId: l,
                  host: r(c),
                  container: s,
                  element: c,
                  ready: function () {
                    !(function (e) {
                      if (e.player) return;
                      var n = e.container.closest(a),
                        r = n.data(o);
                      switch (e.host) {
                        case t.html5:
                          e.player = new Shopify.Plyr(e.element, {
                            loop: { active: r },
                          });
                          break;
                        case t.youtube:
                          var s = n.data(i);
                          e.player = new YT.Player(e.element, {
                            videoId: s,
                            events: {
                              onStateChange: function (e) {
                                0 === e.data && r && e.target.seekTo(0);
                              },
                            },
                          });
                      }
                      n.on("mediaHidden xrLaunch", function () {
                        e.player &&
                          (e.host === t.html5 && e.player.pause(),
                          e.host === t.youtube &&
                            e.player.pauseVideo &&
                            e.player.pauseVideo());
                      }),
                        n.on("mediaVisible", function () {
                          theme.Helpers.isTouch() ||
                            (e.player &&
                              (e.host === t.html5 && e.player.play(),
                              e.host === t.youtube &&
                                e.player.playVideo &&
                                e.player.playVideo()));
                        });
                    })(this);
                  },
                }),
                e[d].host)
              ) {
                case t.html5:
                  window.Shopify.loadFeatures([
                    { name: "video-ui", version: "1.0", onLoad: n },
                  ]),
                    theme.LibraryLoader.load("plyrShopifyStyles");
                  break;
                case t.youtube:
                  theme.LibraryLoader.load("youtubeSdk");
              }
          }
        },
        hosts: t,
        loadVideos: s,
        removeSectionVideos: function (t) {
          for (var a in e)
            if (e.hasOwnProperty(a)) {
              var o = e[a];
              o.sectionId === t &&
                (o.player && o.player.destroy(), delete e[a]);
            }
        },
      };
    })()),
    (theme.ProductModel = (function () {
      var t = {},
        a = {},
        o = {},
        i = "[data-product-single-media-group]",
        n = "[data-shopify-xr]";
      function r(a) {
        if (!a)
          if (window.ShopifyXR) {
            for (var o in t)
              if (t.hasOwnProperty(o)) {
                var i = t[o];
                if (i.loaded) continue;
                var n = e("#ModelJson-" + o);
                window.ShopifyXR.addModels(JSON.parse(n.html())),
                  (i.loaded = !0);
              }
            window.ShopifyXR.setupXRElements();
          } else
            document.addEventListener("shopify_xr_initialized", function () {
              r();
            });
      }
      function s(e) {
        if (!e)
          for (var t in a)
            if (a.hasOwnProperty(t)) {
              var o = a[t];
              o.modelViewerUi ||
                (o.modelViewerUi = new Shopify.ModelViewerUI(o.$element)),
                l(o);
            }
      }
      function l(e) {
        var t = o[e.sectionId];
        e.$container.on("mediaVisible", function () {
          t.$element.attr("data-shopify-model3d-id", e.modelId),
            theme.Helpers.isTouch() || e.modelViewerUi.play();
        }),
          e.$container
            .on("mediaHidden", function () {
              t.$element.attr("data-shopify-model3d-id", t.defaultId),
                e.modelViewerUi.pause();
            })
            .on("xrLaunch", function () {
              e.modelViewerUi.pause();
            });
      }
      return {
        init: function (l, c) {
          (t[c] = { loaded: !1 }),
            l.each(function (t) {
              var r = e(this),
                s = r.data("media-id"),
                l = e(r.find("model-viewer")[0]),
                d = l.data("model-id");
              if (0 === t) {
                var u = r.closest(i).find(n);
                o[c] = { $element: u, defaultId: d };
              }
              a[s] = { modelId: d, sectionId: c, $container: r, $element: l };
            }),
            window.Shopify.loadFeatures([
              { name: "shopify-xr", version: "1.0", onLoad: r },
              { name: "model-viewer-ui", version: "1.0", onLoad: s },
            ]),
            theme.LibraryLoader.load("modelViewerUiStyles");
        },
        removeSectionModels: function (e) {
          for (var o in a) {
            if (a.hasOwnProperty(o))
              a[o].sectionId === e &&
                (a[o].modelViewerUi.destroy(), delete a[o]);
          }
          delete t[e];
        },
      };
    })()),
    (theme.Currency = {
      formatMoney: function (e, t) {
        "string" == typeof e && (e = e.replace(".", ""));
        var a = "",
          o = /\{\{\s*(\w+)\s*\}\}/,
          i = t || "${{amount}}";
        function n(e, t, a, o) {
          if (
            ((t = slate.utils.defaultTo(t, 2)),
            (a = slate.utils.defaultTo(a, ",")),
            (o = slate.utils.defaultTo(o, ".")),
            isNaN(e) || null == e)
          )
            return 0;
          var i = (e = (e / 100).toFixed(t)).split(".");
          return (
            i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
            (i[1] ? o + i[1] : "")
          );
        }
        switch (i.match(o)[1]) {
          case "amount":
            a = n(e, 2);
            break;
          case "amount_no_decimals":
            a = n(e, 0);
            break;
          case "amount_with_comma_separator":
            a = n(e, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            a = n(e, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            a = n(e, 0, " ");
        }
        return i.replace(o, a);
      },
    }),
    (theme.Disclosure = (function () {
      var t = "[data-disclosure-list]",
        a = "[data-disclosure-toggle]",
        o = "[data-disclosure-input]",
        i = "[data-disclosure-option]",
        n = "disclosure-list--visible";
      function r(e) {
        (this.$container = e),
          (this.cache = {}),
          this._cacheSelectors(),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut();
      }
      return (
        (r.prototype = e.extend({}, r.prototype, {
          _cacheSelectors: function () {
            this.cache = {
              $disclosureList: this.$container.find(t),
              $disclosureToggle: this.$container.find(a),
              $disclosureInput: this.$container.find(o),
              $disclosureOptions: this.$container.find(i),
            };
          },
          _connectToggle: function () {
            this.cache.$disclosureToggle.on(
              "click",
              function (t) {
                var a = "true" === e(t.currentTarget).attr("aria-expanded");
                e(t.currentTarget).attr("aria-expanded", !a),
                  this.cache.$disclosureList.toggleClass(n);
              }.bind(this)
            );
          },
          _connectOptions: function () {
            this.cache.$disclosureOptions.on(
              "click",
              function (t) {
                this._submitForm(e(t.currentTarget).data("value")),
                  t.preventDefault();
              }.bind(this)
            );
          },
          _onFocusOut: function () {
            this.cache.$disclosureToggle.on(
              "focusout",
              function (e) {
                0 === this.$container.has(e.relatedTarget).length &&
                  this._hideList();
              }.bind(this)
            ),
              this.cache.$disclosureList.on(
                "focusout",
                function (t) {
                  var a = e(t.currentTarget).has(t.relatedTarget).length > 0;
                  this.cache.$disclosureList.hasClass(n) &&
                    !a &&
                    this._hideList();
                }.bind(this)
              ),
              this.$container.on(
                "keyup",
                function (e) {
                  e.which === slate.utils.keyboardKeys.ESCAPE &&
                    (this._hideList(), this.cache.$disclosureToggle.focus());
                }.bind(this)
              ),
              (this.bodyOnClick = function (e) {
                var t = this.$container.has(e.target).length > 0;
                this.cache.$disclosureList.hasClass(n) &&
                  !t &&
                  this._hideList();
              }.bind(this)),
              e("body").on("click", this.bodyOnClick);
          },
          _submitForm: function (e) {
            this.cache.$disclosureInput.val(e),
              this.$container.parents("form").submit();
          },
          _hideList: function () {
            this.cache.$disclosureList.removeClass(n),
              this.cache.$disclosureToggle.attr("aria-expanded", !1);
          },
          unload: function () {
            e("body").off("click", this.bodyOnClick),
              this.cache.$disclosureOptions.off(),
              this.cache.$disclosureToggle.off(),
              this.cache.$disclosureList.off(),
              this.$container.off();
          },
        })),
        r
      );
    })()),
    (slate.utils = {
      findInstance: function (e, t, a) {
        for (var o = 0; o < e.length; o++) if (e[o][t] === a) return e[o];
      },
      removeInstance: function (e, t, a) {
        for (var o = e.length; o--; )
          if (e[o][t] === a) {
            e.splice(o, 1);
            break;
          }
        return e;
      },
      getBaseUnit: function (e) {
        return 1 === e.unit_price_measurement.reference_value
          ? e.unit_price_measurement.reference_unit
          : e.unit_price_measurement.reference_value +
              e.unit_price_measurement.reference_unit;
      },
      compact: function (e) {
        for (
          var t = -1, a = null == e ? 0 : e.length, o = 0, i = [];
          ++t < a;

        ) {
          var n = e[t];
          n && (i[o++] = n);
        }
        return i;
      },
      defaultTo: function (e, t) {
        return null == e || e != e ? t : e;
      },
      debounce: function (e, t, a) {
        var o;
        return function () {
          var i = this,
            n = arguments,
            r = function () {
              (o = null), a || e.apply(i, n);
            },
            s = a && !o;
          clearTimeout(o), (o = setTimeout(r, t)), s && e.apply(i, n);
        };
      },
    }),
    (slate.Variants = (function () {
      function t(t) {
        (this.$container = t.$container),
          (this.product = t.product),
          (this.singleOptionSelector = t.singleOptionSelector),
          (this.originalSelectorId = t.originalSelectorId),
          (this.enableHistoryState = t.enableHistoryState),
          (this.enableSwatch = t.enableSwatch),
          (this.currentVariant = this._getVariantFromOptions()),
          e(this.singleOptionSelector, this.$container).on(
            "change",
            this._onSelectChange.bind(this)
          );
      }
      return (
        (t.prototype = e.extend({}, t.prototype, {
          _getCurrentOptions: function () {
            var t = e.map(
              e(this.singleOptionSelector, this.$container),
              function (t) {
                var a = e(t),
                  o = a.attr("type"),
                  i = {};
                return "radio" === o || "checkbox" === o
                  ? !!a[0].checked &&
                      ((i.value = a.val()), (i.index = a.data("index")), i)
                  : ((i.value = a.val()), (i.index = a.data("index")), i);
              }
            );
            return (t = slate.utils.compact(t));
          },
          _getVariantFromOptions: function () {
            var e = this._getCurrentOptions(),
              t = this.product.variants,
              a = !1;
            return (
              t.forEach(function (t) {
                var o = !0;
                t.options;
                e.forEach(function (e) {
                  o && (o = e.value === t[e.index]);
                }),
                  o && (a = t);
              }),
              a || null
            );
          },
          _onSelectChange: function () {
            var e = this._getVariantFromOptions();
            this.$container.trigger({ type: "variantChange", variant: e }),
              e
                ? (this._updateMasterSelect(e),
                  this._updateImages(e),
                  this._updatePrice(e),
                  this._updateSKU(e),
                  this._updateSwatches(e),
                  (this.currentVariant = e),
                  this.enableHistoryState && this._updateHistoryState(e))
                : this._updateSwatches(e);
          },
          _updateImages: function (e) {
            var t = e.featured_image || {},
              a = this.currentVariant.featured_image || {};
            e.featured_image &&
              t.src !== a.src &&
              this.$container.trigger({
                type: "variantImageChange",
                variant: e,
              });
          },
          _updatePrice: function (e) {
            (e.price === this.currentVariant.price &&
              e.compare_at_price === this.currentVariant.compare_at_price) ||
              this.$container.trigger({
                type: "variantPriceChange",
                variant: e,
              });
          },
          _updateSKU: function (e) {
            e.sku !== this.currentVariant.sku &&
              this.$container.trigger({ type: "variantSKUChange", variant: e });
          },
          _updateSwatches: function (e) {
            this.$container.trigger({
              type: "variantSwatchChange",
              variant: e,
            });
          },
          _updateHistoryState: function (e) {
            if (history.replaceState && e) {
              var t =
                window.location.protocol +
                "//" +
                window.location.host +
                window.location.pathname +
                "?variant=" +
                e.id;
              window.history.replaceState({ path: t }, "", t);
            }
          },
          _updateMasterSelect: function (t) {
            e(this.originalSelectorId, this.$container)[0].value = t.id;
          },
        })),
        t
      );
    })()),
    (theme.Helpers =
      ((t = !1),
      {
        setTouch: function () {
          t = !0;
        },
        isTouch: function () {
          return t;
        },
        debounce: function (e, t, a) {
          var o;
          return function () {
            var i = this,
              n = arguments,
              r = function () {
                (o = null), a || e.apply(i, n);
              },
              s = a && !o;
            clearTimeout(o), (o = setTimeout(r, t)), s && e.apply(i, n);
          };
        },
      })),
    (theme.LibraryLoader =
      ((i = "requested"),
      (n = "loaded"),
      (s = {
        youtubeSdk: {
          tagId: "youtube-sdk",
          src: "https://www.youtube.com/iframe_api",
          type: (o = "script"),
        },
        plyrShopifyStyles: {
          tagId: "plyr-shopify-styles",
          src:
            (r = "https://cdn.shopify.com/shopifycloud/") +
            "shopify-plyr/v1.0/shopify-plyr.css",
          type: (a = "link"),
        },
        modelViewerUiStyles: {
          tagId: "shopify-model-viewer-ui-styles",
          src: r + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
          type: a,
        },
      }),
      {
        load: function (e, t) {
          var r = s[e];
          if (r && r.status !== i)
            if (((t = t || function () {}), r.status !== n)) {
              var l;
              switch (((r.status = i), r.type)) {
                case o:
                  l = (function (e, t) {
                    var a = document.createElement("script");
                    return (
                      (a.src = e.src),
                      a.addEventListener("load", function () {
                        (e.status = n), t();
                      }),
                      a
                    );
                  })(r, t);
                  break;
                case a:
                  l = (function (e, t) {
                    var a = document.createElement("link");
                    return (
                      (a.href = e.src),
                      (a.rel = "stylesheet"),
                      (a.type = "text/css"),
                      a.addEventListener("load", function () {
                        (e.status = n), t();
                      }),
                      a
                    );
                  })(r, t);
              }
              (l.id = r.tagId), (r.element = l);
              var c = document.getElementsByTagName(r.type)[0];
              c.parentNode.insertBefore(l, c);
            } else t();
        },
      })),
    e.fn.extend({
      productBox: function () {
        var t = e(this).find(".box.product figure");
        t.on("click", function (t) {
          if (e(t.target).is(".vendor") || e(t.target).parent().is(".vendor"));
          else if (
            e(t.target).is(".product-swatches__li") ||
            0 != e(t.target).closest(".product-swatches__li").length
          ) {
            var a = e(t.target).closest(".product-swatches"),
              o = e(t.target).closest(".product-swatches__li"),
              i = o.find("a"),
              n = i.data("variant-image"),
              r = i.data("variant-image-pattern"),
              s = i.data("variant-url"),
              l = o.closest(".box.product").find("a.product_card"),
              c = l.find(".product_card__image:not(.alt)");
            "" !== s && l.attr("href", s),
              "" !== n &&
                c
                  .attr("src", n)
                  .attr("data-fallback", n)
                  .attr("srcset", "")
                  .attr("data-srcset", "")
                  .attr("data-src", r),
              e(".product-swatches__link--selected", a).removeClass(
                "product-swatches__link--selected"
              ),
              i.addClass("product-swatches__link--selected"),
              t.preventDefault();
          } else {
            t.preventDefault();
            var d = e(this).find("a").attr("href");
            t.shiftKey || t.ctrlKey || t.metaKey
              ? window.open(d, "_blank")
              : (window.location = d);
          }
        }),
          "objectFit" in document.documentElement.style == !1 &&
            t.find(".product_card__image-wrapper").each(function () {
              var t = e(this),
                a = t.find(".product_card__image.alt");
              t.find("img").prop("src");
              a.hide(), t.addClass("ie-fallback lazyload");
            }),
          e(this)
            .find(".box.product a.product-swatches__link")
            .on("mouseenter", function (t) {
              StyleHatch.productSwatchPreload =
                StyleHatch.productSwatchPreload || [];
              var a = e(t.target)
                .closest("a.product-swatches__link")
                .data("variant-image");
              "" !== a &&
                StyleHatch.productSwatchPreload.indexOf(a) < 0 &&
                (StyleHatch.productSwatchPreload.push(a),
                (new Image().src = a));
            });
      },
      destroyProductBox: function () {
        e(this).find(".box.product figure").off("click");
      },
      initNestedMenu: function () {
        var t = e(this).find('a[aria-haspopup="true"]'),
          a = function (e) {
            var t = e.find("li.has-sub-dropdown.expanded");
            if (t.length > 0) {
              t.removeClass("expanded"),
                t.find("> a").attr("aria-expanded", "false");
              var o = t.find("> ul.sub-dropdown");
              o.attr("aria-hidden", "true"),
                o.slideUp(),
                o.find("a").attr("tabindex", "-1"),
                a(e);
            }
          };
        t.on("click", function (t) {
          var o = e(this),
            i = o.parent(),
            n = i.find("> ul"),
            r = i.find("> ul > li > a"),
            s = o.closest("ul.nested-menu");
          "true" !== o.attr("aria-expanded") &&
            (t.preventDefault(),
            i.hasClass("has-dropdown")
              ? (function (e) {
                  var t = e.find("li.has-dropdown.expanded");
                  if (t.length > 0) {
                    t.removeClass("expanded"),
                      t.find("> a").attr("aria-expanded", "false");
                    var o = t.find("> ul.dropdown");
                    o.attr("aria-hidden", "true"),
                      o.slideUp(),
                      o.find("a").attr("tabindex", "-1"),
                      a(e);
                  }
                })(s)
              : a(s),
            o.attr("aria-expanded", "true"),
            i.addClass("expanded"),
            n.attr("aria-hidden", "false"),
            r.attr("tabindex", "0"),
            n.slideDown());
        });
      },
      destroyNestedMenu: function () {
        e(this).find('a[aria-haspopup="true"]').off("click");
      },
    }),
    (StyleHatch.refreshFixTo = function () {
      StyleHatch.Promos.refreshFixTo(),
        e("*")
          .filter(function () {
            return e(this).data("fixtoInstance");
          })
          .each(function (t) {
            e(this).data("fixto-instance")._running && e(this).fixTo("refresh");
          });
    }),
    (StyleHatch.videoLayout = function () {
      e(".rte").fitVids(),
        e(".rte").find("table").wrap('<div class="table-wrapper"></div>');
    }),
    (StyleHatch.loginForms = function () {
      function e() {
        StyleHatch.cache.$recoverPasswordForm.show(),
          StyleHatch.cache.$customerLoginForm.hide();
      }
      StyleHatch.cache.$recoverPasswordLink.on("click", function (t) {
        t.preventDefault(), e(), StyleHatch.updateHash("recover");
      }),
        StyleHatch.cache.$hideRecoverPasswordLink.on("click", function (e) {
          e.preventDefault(),
            StyleHatch.cache.$recoverPasswordForm.hide(),
            StyleHatch.cache.$customerLoginForm.show(),
            StyleHatch.updateHash();
        }),
        "#recover" == StyleHatch.getHash() && e();
    }),
    (StyleHatch.initTemplates = function () {
      switch (StyleHatch.cache.$body.data("template")) {
        case "addresses":
          StyleHatch.initCustomerAddressTemplate();
      }
    }),
    (StyleHatch.initCustomerAddressTemplate = function () {
      StyleHatch.addressJSValidation &&
        e('.customer-address input[type="submit"]').on("click", function (t) {
          var a = e(this).closest("form"),
            o = a.find('input[name="address[last_name]"]'),
            i = a.find('input[name="address[address1]"]'),
            n = a.find('input[name="address[city]"]'),
            r = a.find('select[name="address[country]"]'),
            s = a.find('select[name="address[province]"]'),
            l = a.find('input[name="address[zip]"]');
          o.val() || o.addClass("required"),
            i.val() || i.addClass("required"),
            n.val() || n.addClass("required"),
            "---" == r.val() && r.addClass("required"),
            s.closest(".input-row").is(":visible") &&
              ((s.val() && "---" != s.val() && "" != s.val()) ||
                s.addClass("required")),
            l.val() || l.addClass("required");
          var c = a.find("input.required, select.required");
          c.on("focus", function () {
            e(this).removeClass("required");
          }),
            c.length > 0
              ? (a.find("div.errors").parent().show(), t.preventDefault())
              : a.find("div.errors").parent().hide();
        });
    }),
    (StyleHatch.updateHash = function (t) {
      t
        ? ((window.location.hash = "#" + t),
          e("#" + t)
            .attr("tabindex", -1)
            .focus())
        : (window.location.hash = "");
    }),
    (StyleHatch.getHash = function () {
      return window.location.hash;
    }),
    (StyleHatch.quantitySelect = function () {
      e(".quantity-select:not([data-quantity-select-enabled])").each(function (
        t
      ) {
        var a = e(this),
          o = a.find(".adjust-minus"),
          i = a.find(".adjust-plus"),
          n = a.find("input.quantity"),
          r = n.val();
        n.on("click", function (e) {
          e.preventDefault();
        }),
          o.on("click", function (e) {
            (r = n.val()) > 0 && (r--, n.val(r)), e.preventDefault();
          }),
          i.on("click", function (e) {
            (r = n.val()), r++, n.val(r), e.preventDefault();
          }),
          a.attr("data-quantity-select-enabled", "true");
      });
    }),
    (StyleHatch.resetPasswordSuccess = function () {
      StyleHatch.cache.$passwordResetSuccess.show();
    }),
    e(document).ready(function () {
      StyleHatch.init();
    });
})(jq223);

/* EPS */

/* OVE Optimization */

!function($) {
  'use strict';

  // Function to check if it's a mobile device based on screen width
  function isMobile() {
    return $(window).width() < 768;  // Adjust 768px according to your design's mobile breakpoint
  }

  $('.mega-nav > li.has-dropdown > a').on('click', function(e) {
    if (isMobile()) {
      e.preventDefault();
      if ($(this).closest('li').hasClass('open')) {
        $(this).closest('li').removeClass('open');
      } else {
        $('.mega-nav li.has-dropdown').removeClass('open');
        $(this).closest('li').addClass('open');
      }
      return false;
    }
  });

  $('.mega-nav .mega-nav-sublink-heading').on('click', function(e) {
    if (isMobile()) {
      var $sublinkColumn = $(this).closest('.sublink-column');
      if (!$sublinkColumn.hasClass('open')) {
        e.preventDefault();
        $('.mega-nav .sublink-column').removeClass('open');
        $sublinkColumn.addClass('open');
      }
    }
  });

  $('.mobile-toggle').on('click', function() {
    $('nav.nav-bar').toggle();
  });

}(jq223);